/**
 * @title mathtable.js: Sub-module
 * @description Associated with MathTableAndProductOptions.jsp
 * This JS file calculates prices of products, shows/hides the 
 * math table on the Product Details Page
 */
define(['product_helper'], function(phelper) {
	var retryCount=0;
	var retryLimit=3;
	var isRegionalPdtAvlble=false;
	var initSwatch = false;
	var isRegionalPdt=false;
	var backordered=false;
	var	bundlePriceMap = new Map();
	var blockContractAjax=false;
	var previousContractAjaxItem='';
  	var selectedObj = null;
	var selectedVar = null ;
	var initalizeAjaxCall=false;
	var hideBreakdownvariants=false;
	var isCostcoMembers = false;
	var isUserSignedIn = false;
	var CMath = {
			isBackOrderFlag : false,
			invAvailableAjax : false,
			invokebatchCall : false,
			pdpPageloadComplete : false,
			kbPageloadComplete : false,
			siteControllOOS: false,
			isWarehouseEnabled :false,
			isWioEnabled : false,
			isBopiwEnabled : false,
			isErrorlocationControlleditem : false,
			invokeAjaxCall : false,
			selectedswatches : [],
			onloadSelectOption : [],
            variantJSON :[],
            varItemJSON : [],
			iskitsbundle: false,
		/* Math Table Controller */
		// Initializes the controller. Checks what kind of product the user landed on executes accordingly.
		init : function() {
			if( isPDPVariantGreyOutEnabled == 'true'){
			 localStorage.setItem('variantStatus',JSON.stringify( COSTCO.CMath.variantJSON));
			}
			var bundleItem=$('#bundleItem').val();
			var scheduledDeliverable = $('#scheduledDeliverable').val() == "true"? true:false;
			var isWarehouseOnlyAttr = $('#isWarehouseOnlyAttr').val() == "true"? true:false;
			var pricingtextdisplay = $('#pricingtextdisplay').val() == 'true'? true:false;
			
			
			if(isWarehouseOnlyAttr && pricingtextdisplay && ($('#applicationType').val() == 'BC')){
				 $('#warehouseonly_pricing_info').removeClass('hide');
			}			
		
			COSTCO.CMath.iskitsbundle = $('#iskitsbundle').val()=="true"? true:false;
			 if($('#isBDAppVar').val() != 'BD' && isPDPVariantGreyOutEnabled == 'true' && ( !(typeof product != 'undefined' && Array.isArray(product) && product.length && product[0].isComingSoon && comingSoonFeatureFlag) && !scheduledDeliverable)){
			$('head').append('<style type="text/css">.loading {animation: pulse 1.5s ease-in-out 0.5s 50;}@keyframes pulse {0% {opacity: 1;}50% {opacity: 0.4;}100% {opacity: 1;}}</style>');
            }
			 if($('#isBDAppVar').val() != 'BD' && bundleItem &&  product.length ==0){
                $('.crumbs').show();
                $('#product-page').addClass('hide');
                $('#not_found_error_pdp').removeClass('hide');
			}
			if (phelper.isSingleItem(products)) {
				$('.starting-price').hide();
				var catentry = $('.online-price').data('catentry');
				var quickView =  $('#quick_view').val()=="true"? true:false;
				phelper.item_type = 'single';
				 if($('#isBDAppVar').val() != 'BD' && !quickView){
				 window.reactObj.fulfillments.buyInStoreOnly.wcsVariant =false;
				 window.reactObj.fulfillments.buyInStoreOnly.readInvFromBatchApi =false;
				 }
				if (catentry) {
					
					if($('#isBDAppVar').val() == 'BD' || quickView) {
					CMath.pricingInfo(catentry);
					CMath.showBreakdown(!hideBreakdownvariants);
					CMath.showBackorderMessage();
					}
				} else {
					$('.your-price').addClass('hide');
				}
				var catID = products[0][0].catentry;
				COSTCO.Product.active_catentry = catID;
				COSTCO.CMath.invokeBuildABundle(catID);
				let defaultItemNumber = COSTCO.Product.getPartnumber();
				window.eventBus.subscribe('reactReady',data => {
					 window.eventBus.publish('bfImageViewerPartnumber',defaultItemNumber);
				 })
			} else if (phelper.isSingleVariant(products)) {
				phelper.item_type = 'single_variant';
				
				if(COSTCO.CMath.iskitsbundle){
					COSTCO.CMath.buildTooltip();
					CMath.selectCurrentSelectedItem();
				}
				COSTCO.Product.sort_variant_options();
				CMath.bindVariantProducts();
				let optionsSelected = COSTCO.Product.get_selected_array($('.varis[data-product=0]').find('option:selected'));
				if( (Array.isArray(product) && product.length && product[0].isComingSoon && comingSoonFeatureFlag) || scheduledDeliverable){
					$('#PDPSwatchSkeletone-productOption0'+parseInt(optionsSelected.length-1)+'').hide();
					$('#swatchesID-productOption0'+parseInt(optionsSelected.length-1)+'').show();
					$('.dropdown-skeleton-productOption0'+parseInt(optionsSelected.length-1)+'').hide();
					$('[name=productOption0'+parseInt(optionsSelected.length-1)+']').show();
				}
			} else if (phelper.isMultiVariant(products)) {
				phelper.item_type = 'multi_variant';
				
				if(COSTCO.CMath.iskitsbundle){
					COSTCO.CMath.buildTooltip();
					CMath.selectCurrentSelectedItem();
				}
				COSTCO.Product.sort_variant_options();
				CMath.bindVariantProducts();
				if($('#isBDAppVar').val() != 'BD' &&  isPDPVariantGreyOutEnabled == 'true' ){
					let optionsSelected = COSTCO.Product.get_selected_array($('.varis[data-product=0]').find('option:selected'));
					for(var i=0; i<=optionsSelected.length-2;i++){
						$('#PDPSwatchSkeletone-productOption0'+parseInt(i)+'').hide();
						$('#swatchesID-productOption0'+parseInt(i)+'').show();
						$('.dropdown-skeleton-productOption0'+parseInt(i)+'').hide();
						$('[name=productOption0'+parseInt(i)+']').show();
					}
					if( (Array.isArray(product) && product.length && product[0].isComingSoon && comingSoonFeatureFlag) || scheduledDeliverable){
						$('#PDPSwatchSkeletone-productOption0'+parseInt(optionsSelected.length-1)+'').hide();
						$('#swatchesID-productOption0'+parseInt(optionsSelected.length-1)+'').show();
						$('.dropdown-skeleton-productOption0'+parseInt(optionsSelected.length-1)+'').hide();
						$('[name=productOption0'+parseInt(optionsSelected.length-1)+']').show();
					}
				  }
				
			}else if(COSTCO.CMath.iskitsbundle){

				phelper.item_type = 'single_variant';
				COSTCO.Product.sort_variant_options();
				CMath.bindVariantProducts();
			
			}else if (phelper.isBundle(products)) {
				phelper.item_type = 'bundle';
				if($('#isBDAppVar').val() != 'BD') {
				for(var i = 0; i < product.length; i++) {
					var productId = product[i].catentry;
					var count =0,size=product.length;
					count= i ;
					for(var j = 0;j < products[i].length; j++){
						var itemId = products[i] [j].catentry;
					//CMath.showBundleSpecificData(productId,itemId,count,size);
					CMath.callAjaxBundleInventory(productId,itemId,count,size);
			}
				}
				}
				CMath.addToCartSwitch(false);
				CMath.bindQuantitiesForBundle();
				CMath.bindVariantProducts('bundle');
				
				if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_PDP_FEATURE_ENABLE) {
					CMath.updateItemNumberDisplay();
				}
			}
			CMath.regionSelector();
			CMath.mathTableDisplayRules();
			if($('#isBDAppVar').val() == 'BD'){
				CMath.showPriceVariants();
			}
			var userInfo = COSTCO.util.getMemberCookie(), signedIn = userInfo.signedIn, costcoMember = userInfo.costcoMember != 'undefined' ? userInfo.costcoMember : false,isCostcoMembers = costcoMember,
					memberOnly = $('#memberItem').val()=="true"? true:false;  
					
			if(COSTCO.CMath.iskitsbundle  && !isUserSignedIn && memberOnly  ){
				$('#bundle-button-container').addClass('hide');
			}
			if(COSTCO.CMath.iskitsbundle  && isUserSignedIn && isCostcoMembers ){
				$('#bundle-button-container').removeClass('hide');
			}
			if(COSTCO.CMath.iskitsbundle  && !isUserSignedIn && !memberOnly && mapItem  ){
				$('#bundle-button-container').addClass('hide');
			}
			
			//Grocery US change - Depot Catalog Online - Call Ajax for contract specific details 
			if(CMath.isContractSpecificAjaxRequired()){
				if(!COSTCO.CMath.iskitsbundle){
				CMath.handleContractSpecificRules();
				}
			}	
			if($('#delivery-zip').val() != undefined){
				$('#delivery-zip').val($.cookie('invCheckPostalCode'));
			}
			
			// Single Product EDD setup
			if (Array.isArray(products) && products.length > 0) {
				
				var defaultShipcode = "";	

				if ($('#defaultShipcode').length != 0) {
					defaultShipcode=$('#defaultShipCode').val();
				}
				
				$('#showLiveEDD').val(products[0][0].eddVendorName);
				$('#vendorName').val(products[0][0].eddVendorName);
				
				if (!COSTCO.util.isEDDEnabled() || !CMath.isValidShipMode(defaultShipcode)) {
					$('#showLiveEDD').val("");
					$('#vendorName').val("");
				}
			}  
			if(!COSTCO.CMath.iskitsbundle){
				CMath.handleEDDForms();
			 }			
			if(phelper.isSingleItem(products) && $('#vendorName').length > 0 ) {
				if (COSTCO.Header.hasInvPostalCodeCookie() && COSTCO.Header.isInvStateCookieMissing() ) {
					let zipcode = $.cookie('invCheckPostalCode');
					let updateZipCodeStateCookies = function(data, textstatus, XMLHttpRequest) {
			    					
						let locationData = COSTCO.Header.extractLocationData(data);
						let invalidZip = locationData.InvalidZip;
				    	let province = locationData.Province;
						let country = locationData.Country;
						
			  	  		if(!invalidZip) {
			  	  			COSTCO.Header.setDeliveryCookies(zipcode, province, country);
				  	  		
			  	  			if ((typeof($.cookie('invCheckPostalCode')) === 'undefined' || $.cookie('invCheckPostalCode') == null) &&  !$('#vendorName').val().toLowerCase().includes('narvar') && $('#edd-form-block').length > 0 ) {
								COSTCO.Product.showEddForm();
							} else if ($.cookie('invCheckPostalCode') != null  && $('#liveEDD')  && $('#liveEDD').val() === "true" && !$('#vendorName').val().toLowerCase().includes('narvar') && $('#edd-form-block').length > 0) {
								COSTCO.Product.displayEDDForm = false;
								COSTCO.Product.retrieveEDD();
							} else if ( $('#liveEDD')  && $('#liveEDD').val() === "true" && $('#vendorName').val().toLowerCase().includes('narvar')  && $('.edd-container').length > 0) {
								COSTCO.Header.itemPartNumberSelcted = products[0][0].partNumber;
								COSTCO.Header.showEDDWidget();
							} else if(typeof(product) !== 'undefined' && typeof(product[0]) !== 'undefined' && product[0].isScheduledDeliverable === "true") {
								var url = "AjaxDeliveryReservationCalendarCmd?storeId="+wcs.storeId+"&deliveryVendorSku=" + $('#deliveryVendorSku').val() + "&zipCode=" + $.cookie('invCheckPostalCode') + "&productSku=" + $('#productPartnumberVal').val();
								COSTCO.ScheduledDeliverable.submitDeliverableAvailabilityAjax({
					                sku: $('#deliveryVendorSku').val(),
					                url: url,
					                productSku : $('#productPartnumberVal').val(),
					                zipCode: $.cookie('invCheckPostalCode')
					            });
							}
			  	  		}
			    	};
			    	if ($('#isGeocodeService').val() != "true") {
			    		COSTCO.util.callBing(zipcode, updateZipCodeStateCookies, updateZipCodeStateCookies);
			    	} else {
			    		COSTCO.util.callGeocodeAPI(zipcode, updateZipCodeStateCookies, updateZipCodeStateCookies);
			    	}
				} else {
					if ((typeof($.cookie('invCheckPostalCode')) === 'undefined' || $.cookie('invCheckPostalCode') == null)  && !$('#vendorName').val().toLowerCase().includes('narvar') && $('#edd-form-block').length > 0) {
						COSTCO.Product.showEddForm();
					} else if ($.cookie('invCheckPostalCode') != null && $('#liveEDD')  && $('#liveEDD').val() === "true" && !$('#vendorName').val().toLowerCase().includes('narvar') && $('#edd-form-block').length > 0) {
						COSTCO.Product.displayEDDForm = false;
						COSTCO.Product.retrieveEDD();
					} else if ($('#liveEDD')  && $('#liveEDD').val() === "true" && $('#vendorName').val().toLowerCase().includes('narvar')  && $('.edd-container').length > 0) {
						COSTCO.Header.itemPartNumberSelcted = products[0][0].partNumber;
						COSTCO.Header.showEDDWidget();
					} else if (typeof(product) !== 'undefined' && typeof(product[0]) !== 'undefined' && product[0].isScheduledDeliverable === "true") {
						var url = "AjaxDeliveryReservationCalendarCmd?storeId="+wcs.storeId+"&deliveryVendorSku=" + $('#deliveryVendorSku').val() + "&zipCode=" + $.cookie('invCheckPostalCode') + "&productSku=" + $('#productPartnumberVal').val();
						COSTCO.ScheduledDeliverable.submitDeliverableAvailabilityAjax({
			                sku: $('#deliveryVendorSku').val(),
			                url: url,
			                productSku : $('#productPartnumberVal').val(),
			                zipCode: $.cookie('invCheckPostalCode')
			            });
					}
						
				}
				// onclick of pills bfImageViewerPartnumber will be published
				window.eventBus.publish('bfImageViewerPartnumber',COSTCO.Header.itemPartNumberSelcted);
				window.reactObj.defaultItemNumber= COSTCO.Header.itemPartNumberSelcted;
			}
			
			try{
				COSTCO.util.checkAndDisableSignInButton();
			}catch(ignore){}
			
		},
		
		swatchTileSelected: false,
		swatchInitialTileSelected: false,
		allVariantsSelected:false,
		swatchActiveColor: '',
		changeVariantTriggered: false,
		preSelectedAttributesPassed:false,
		preSelectedAttributesChanged:false,
		
		// A sequence of functions that shows the online price, fees/discounts, calculates and shows (if not bundle) "Your Price"
		pricingInfo : function(catentryid,priceOnline) {
			CMath.showOnlinePrice(catentryid);
			CMath.processEcoFee(catentryid,priceOnline);
			//Commented out the below lines as part of Canada Compliance changes
			//CMath.showFeesAndDiscounts(catentryid);
			//CMath.calculateYourPrice(catentryid);
			CMath.showTaxableFoodAttribute(catentryid);
		},
		//Implemented as part of Canada Compliance changes
		showDiscountsBreakdown: function (catentryid) {
		    const $disc = $(`.disc[data-catentry=${catentryid}]`);
		    const $discValue = $disc.find('.disc-value');

		    CMath.hideElements($('.disc'), $('.disc .disc-value'));
		    CMath.showLocalizedValues($disc, $discValue, $disc.data('disc'));

		    const discText = $discValue.text().trim();
		    const isDiscEmpty = discText === '' || discText === '--';
		    const hasHideClass = $disc.hasClass('hide');

		    if (isDiscEmpty) {
		        $disc.toggleClass('active hide');
		    } else if (!isDiscEmpty && hasHideClass) {
		        $disc.toggleClass('hide active');
		    }
		},
		//Implemented as part of Canada Compliance changes
		showFeeBreakdown: function (catentryId, feeArray) {
		    CMath.hideElements($('.fees'), $('.fees .fee-value'));

		    const loc = $.cookie('C_LOC');
		    if (!loc || loc.length <= 2 || !Array.isArray(feeArray)) return;
		    document.querySelectorAll(`.fees.${loc}[data-catentry="${catentryId}"]`).forEach(feeElement => {
		        const feeType = feeElement.getAttribute('data-feeType');
		        if (feeArray.includes(feeType)) {
		            const $feeElement = $(feeElement);
		            CMath.showLocalizedValues($feeElement, $feeElement.find('.fee-value'), $feeElement.data('feeamt'));
		        }
		    });
		},
		//Implemented as part of Canada Compliance changes
		processEcoFee: function (catentryId, priceOnline) {
		    const currentRegion = COSTCO.util.getRegion();
		    var ecoFeesConfigurations = (typeof feesConfigurations !== 'undefined') ? feesConfigurations : null;
		    let discount = $('.disc[data-catentry=' + catentryId + ']').data('disc');
		    discount = discount ? parseFloat(COSTCO.util.decode(discount).replace(/,/g, '')) : 0;

		    if (discount) {
		        $('.disc[data-catentry=' + catentryId + ']').toggleClass('active hide');
		        CMath.showBreakdown(true, catentryId);
		        CMath.showDiscountsBreakdown(catentryId);
		    } else {
		        CMath.hideElements($('.disc'), $('.disc .disc-value'));
		    }
		    if (priceOnline) {
		        $(`.online-price[data-catentry=${catentryId}] .op-value`).text(phelper.formatMoney(phelper.processPrice(priceOnline)));
		        $(`.online-price[data-catentry=${catentryId}]`).data('opvalue', COSTCO.util.encode(String(priceOnline)));
		    }

		    let opPrice = COSTCO.util.decode($(`.online-price[data-catentry=${catentryId}]`).data('opvalue')) || 0;
		    opPrice = parseFloat(opPrice.toString().replace(/,/g, '')) || 0;

		    const regionECOConfig  = CMath.getRegionFeeConfig(ecoFeesConfigurations, currentRegion, "EcoFee");
		    const regionDepositConfig  = CMath.getRegionFeeConfig(ecoFeesConfigurations, currentRegion, "Deposit");
		    const regionOtherConfig  = CMath.getRegionFeeConfig(ecoFeesConfigurations, currentRegion, "OtherFee");
		    const categoryConfigMap = {
		    	    EcoFee: regionECOConfig,
		    	    Deposit: regionDepositConfig,
		    	    OtherFee: regionOtherConfig
		    	  };
		    const feeIdMap = {
		    	    EcoFee: [],
		    	    Deposit: [],
		    	    OtherFee: []
		    	  };
		    const loc = $.cookie('C_LOC');
		    if (!loc || loc.length <= 2 ){
		    	 CMath.showFeeBreakdown(catentryId, null);
		    	 CMath.calculateYouPriceV2(catentryId, false, opPrice, discount);
			     return;
		    }
		    const feeElements = $(`.fees.${loc}[data-catentry=${catentryId}]`);
		    document.getElementById("linkfee-container").innerHTML = "";
		    let regionfees = [];// feeIds eligible for the provience
		    feeElements.each(function () {
		        const feeType = this.getAttribute('data-feeType');
		        const feeCategory = this.getAttribute('data-feeCategory');
		        if (feeCategory && feeType && feeType.trim() !== "") {
		          const config = categoryConfigMap[feeCategory];
		          if (config) {
		            feeIdMap[feeCategory].push(feeType);
		          }
		        }
		    });
		    if(!feeElements || feeElements.length === 0){
		    	 CMath.showFeeBreakdown(catentryId, null);
		    	 CMath.calculateYouPriceV2(catentryId, false, opPrice, discount);
			      return;
		    }
		    if (!regionECOConfig) {
		        console.warn("Region configuration not found");
		        CMath.showFeeBreakdown(catentryId, null);
		        if(regionECOConfig || regionDepositConfig || regionOtherConfig){
		        	CMath.ecoFeeBreakdownDisplay(feeIdMap, null, catentryId, null, opPrice);
		        }
		        CMath.calculateYouPriceV2(catentryId, false, opPrice, discount);
		        return;
		    }
		    if (regionECOConfig.feeType !== "ALL") {
		    	regionfees = regionECOConfig.feeType.split(',');
			}

		    const displayLogic = {
		    	INTERNALIZED: () => {
		            const ecofeetotal = CMath.ecoFeeBreakdownDisplay(feeIdMap,regionfees, catentryId, categoryConfigMap, opPrice);
		            const combinedPrice = (opPrice + ecofeetotal).toFixed(2);
		            if (ecofeetotal > 0) {
		                const clonedContent = document.getElementById('priceBreakdown').cloneNode(true);
		                clonedContent.removeAttribute('id');
		                clonedContent.className = 'ecofee-details';
		                var parentDiv = null;
		                if(discount > 0){
		                	parentDiv = document.querySelector(`.online-price[data-catentry="${catentryId}"]`);
		                }else{
		                	parentDiv = document.querySelector(`.your-price`);
		                }
		                parentDiv.parentNode.insertBefore(clonedContent, parentDiv.nextSibling);
		                var locale = COSTCO.util.getLocale();
	                	 if(locale == 'fr-CA' && discount > 0){
	                		 document.querySelector('.ecofee-details').style.paddingLeft = '150px';
	                	 }
		                document.getElementById('priceBreakdown').innerHTML = "";
		            }
		            CMath.showFeeBreakdown(catentryId, null);
		            CMath.calculateYouPriceV2(catentryId, false, combinedPrice, discount);
		            if (combinedPrice) {
		                $(`.online-price[data-catentry=${catentryId}] .op-value`).text(phelper.formatMoney(combinedPrice));
		                $(`.online-price[data-catentry=${catentryId}]`).data('opvalue', combinedPrice);
		            }
		        },
		        HIDDEN: () => {
		            CMath.showFeeBreakdown(catentryId, null);
		            const ecofeetotal = CMath.ecoFeeBreakdownDisplay(feeIdMap,regionfees,catentryId, categoryConfigMap, opPrice);
		            const combinedPrice = (opPrice + ecofeetotal).toFixed(2);
		            CMath.calculateYouPriceV2(catentryId, false, combinedPrice, discount);
		            if (ecofeetotal) {
		                $(`.online-price[data-catentry=${catentryId}] .op-value`).text(phelper.formatMoney(combinedPrice));
		                $(`.online-price[data-catentry=${catentryId}]`).data('opvalue', combinedPrice);
		            }
		        },
		        MATHTABLE: () => {
		            CMath.showBreakdown(true, catentryId);
		            CMath.showFeeBreakdown(catentryId, feeIdMap["EcoFee"]);

		            const ecofeetotal = CMath.ecoFeeBreakdownDisplay(feeIdMap,regionfees, catentryId, categoryConfigMap, opPrice);
		            const totalSplit = opPrice + ecofeetotal;
		            CMath.calculateYouPriceV2(catentryId, false, totalSplit, discount);
		        },
		        STANDARD: () => {
		            CMath.showFeeBreakdown(catentryId, null);
		            CMath.ecoFeeBreakdownDisplay(feeIdMap, null, catentryId, categoryConfigMap, opPrice);
		            CMath.calculateYouPriceV2(catentryId, false, opPrice, discount);
		        }
		    };

		    (displayLogic[regionECOConfig.display.PDP] || displayLogic.STANDARD)();
		    
		    $('.co-help.eco-fee').popover();
		},

		ecoFeeBreakdownDisplay: function (feeIdMap, regionfees, catentryId, displayConfig, opValue) {
			if (!displayConfig || (!feeIdMap["EcoFee"] || feeIdMap["EcoFee"].length === 0) &&
					  (!feeIdMap["Deposit"] || feeIdMap["Deposit"].length === 0) &&
					  (!feeIdMap["OtherFee"] || feeIdMap["OtherFee"].length === 0)) {
				  return 0;
			}
			let ecoFeeTotal = 0;
			let ecoFeeTotalHidden = 0;
			const noEcoFeeInRegion = 
				  Array.isArray(regionfees) && regionfees.length > 0 &&
				  Array.isArray(feeIdMap.EcoFee) && feeIdMap.EcoFee.length > 0 &&
				  feeIdMap.EcoFee.some(id => !regionfees.includes(id));
			document.getElementById("linkfee-container").innerHTML = "";
		    const container = document.getElementById("linkfee-container");
		    const location = $.cookie('C_LOC');
		    const elements = document.querySelectorAll(`.fee-parent .fees.${location}[data-catentry="${catentryId}"]`);
		    let tooltip = null;
		    let ecoFeeHiddenTextAdded = false;
		    let ecoFeeDisplay = null;
		    elements.forEach(feeElement => {
		        const feeType = feeElement.getAttribute('data-feeType');
		        if (!feeType) return;
		        let feeCategory = null;
		        for (const category in feeIdMap) {
		            if (feeIdMap[category].includes(feeType)) {
		                feeCategory = category;
		                break;
		            }
		        }
		        const decodedAmount = parseFloat(atob(feeElement.getAttribute('data-feeamt')));
		        const labelElement = feeElement.querySelector(".fee-label");
	        	const label = labelElement ? COSTCO.util.sentenceToPascalCase(labelElement.innerText.trim()) : "";
	        	const ecoFeeElement = feeElement.querySelector(".co-help.eco-fee");
	        	const linkFeeElement = feeElement.querySelector(".eco-fee"); 
		        const tooltipClone =  ecoFeeElement ? ecoFeeElement.cloneNode(true) : linkFeeElement ? linkFeeElement.cloneNode(true) : "";
		        const isRegionFee = (regionfees != null && regionfees.length > 0) ? regionfees.includes(feeType) : true;
		        const isEcoFee = (feeCategory == 'EcoFee') && isRegionFee;
		        const config = displayConfig[feeCategory];
		        const pdpDisplay = config && config.display ? config.display.PDP : null;
		        if (isEcoFee && (pdpDisplay === 'INTERNALIZED' || pdpDisplay === 'MATHTABLE')) {
		            ecoFeeTotal += decodedAmount;
		            tooltip = tooltipClone;
		            ecoFeeDisplay = pdpDisplay;
		        } else if (isEcoFee && pdpDisplay === 'HIDDEN' && isRegionFee) {
		        	if(!noEcoFeeInRegion){
		        		ecoFeeTotalHidden += decodedAmount;
		        		if(!ecoFeeHiddenTextAdded ){
		        			ecoFeeHiddenTextAdded = true;
		        			container.appendChild(CMath.createFeeRow(label, messages.ECO_FEE_INCLUDED, tooltipClone));
		        		}
		        	}else{
		        		 ecoFeeTotal += decodedAmount;
		        	}
		        } else {
		        	var ecofeeamount = phelper.formatMoney(phelper.processPrice(decodedAmount.toFixed(2)),true);
		            container.appendChild(CMath.createFeeRow(label, `+${ecofeeamount}`, tooltipClone));
		        }
		    });

		    if (ecoFeeTotal > 0 && ecoFeeDisplay === 'INTERNALIZED') {
		        const breakdownDiv = document.getElementById('priceBreakdown');
		        var itemprice = phelper.formatMoney(phelper.processPrice(opValue.toFixed(2)),true);
		        var totalEcofeeAmount = phelper.formatMoney(phelper.processPrice(ecoFeeTotal.toFixed(2)),true);
		        breakdownDiv.innerHTML = `(${itemprice} + ${totalEcofeeAmount} ${messages.PDETAIL_ECOFEE_TEXT}<span class="eco-fee-tool"></span>)`;
		        if (tooltip) breakdownDiv.querySelector(".eco-fee-tool").appendChild(tooltip);
		    }
		    if(ecoFeeTotalHidden > 0){
	    		 let discount = $('.disc[data-catentry=' + catentryId + ']').data('disc');
			     discount = discount ? parseFloat(COSTCO.util.decode(discount).replace(/,/g, '')) : 0;
			     if (discount > 0) {
			    	 opValue -= discount
			     }
		    	 const combinedPrice = (opValue + ecoFeeTotalHidden).toFixed(2);
		    	 var addedprice = phelper.formatMoney(phelper.processPrice(combinedPrice),true);
		    	 document.getElementById("ecoFeeHiddenLayout_" + catentryId).value = addedprice;
		    }

		    return ecoFeeTotal;
		},
		createFeeRow : function (label, valueHtml, tooltipElement) {
	        const div = document.createElement("div");
	        div.className = "fee-row linkfee_";
	        div.innerHTML = `
	            <div class="fee-name linkfee_">${label}</div>
	            <div class="fee-info-icon linkfee_"></div>
	            <div class="fee-value pull-right">${valueHtml}</div>
	        `;
	        if (tooltipElement) div.querySelector(".fee-info-icon").appendChild(tooltipElement);
	        return div;
		},
		getRegionFeeConfig : function (feeDisplayConfig, currentRegion, feeCategory) {
		  if (!feeDisplayConfig) return null;
		  const regionFees = feeDisplayConfig[currentRegion] || feeDisplayConfig["ALL"] || [];
		  return regionFees.find(fee => fee.feeCategory === feeCategory) || null;
		},
		// A utility function that first hides the "Online Price" for each product on the page and then shows the particular "Online Price" (div) associated with the passed catentryId 
		showOnlinePrice : function(catentryid){
			CMath.hideElements($('.online-price'), $('.online-price .op-value'));
			CMath.useRegionFeeIncludedOpValue($('.online-price[data-catentry='+catentryid+']'), catentryid);
			
		},
		// A utility function that first hides the "Fees / Discounts" for each product on the page and then shows the particular "Fees / Discounts" (divs) associated with the passed catentryId
		showFeesAndDiscounts : function(catentryid){
			CMath.hideElements($('.disc'), $('.disc .disc-value')); CMath.hideElements($('.fees'), $('.fees .fee-value'));
			CMath.showLocalizedValues($('.disc[data-catentry='+catentryid+']'), 
									$('.disc[data-catentry='+catentryid+'] .disc-value'),
									$('.disc[data-catentry='+catentryid+']').data('disc'))
			if($('.disc[data-catentry='+catentryid+'] .disc-value').text() == '' || $('.disc[data-catentry='+catentryid+'] .disc-value').text() == '--'  ){
				$('.disc[data-catentry='+catentryid+']').toggleClass('active hide');
			}else if(($('.disc[data-catentry='+catentryid+'] .disc-value').text() != '' ||$('.disc[data-catentry='+catentryid+'] .disc-value').text() != '--') 
					&& $('.disc[data-catentry='+catentryid+']').hasClass('hide') ){
				 $('.disc[data-catentry='+catentryid+']').toggleClass('hide active');
			}
			if ($.cookie('C_LOC') !=null){
				if ($.cookie('C_LOC').length>2 ){
					if ($('.fees.'+$.cookie('C_LOC')+'[data-catentry='+catentryid+']').length>0) { // fees exist for this region
						$('.fees.'+$.cookie('C_LOC')+'[data-catentry='+catentryid+']').each(function() {
							var isFeeCombined = false;
							if(typeof feesCombineWithPrice !== 'undefined'){
								for (var i = 0; i < feesCombineWithPrice.length; i++) {
									var config = feesCombineWithPrice[i];
									if (config.region == $.cookie('C_LOC') && config.feeId == $(this).data('feeid')) {
										isFeeCombined = true;
										break;
									}
								}
							}
							if(isFeeCombined == false){
								CMath.showLocalizedValues($(this), $(this).find('.fee-value'), $(this).data('feeamt'));
							}
						});
					}
				}
			}
		},
		//Method to display the taxable food item label in the PDP page
		showTaxableFoodAttribute : function() {
			if(typeof taxableCatalogsAttributes !== 'undefined' && taxableCatalogsAttributes != null){
				for (var i = 0; i < taxableCatalogsAttributes.length; i++) {
					var taxableAttr = taxableCatalogsAttributes[i];
					var regionCode = $.cookie('C_LOC');
					if (regionCode !== 'undefined' && regionCode != null && 
							taxableAttr.value === regionCode.slice(-2)) {
						$("#taxable-item").removeClass('hide');
						break;
					} else {
						$("#taxable-item").addClass('hide');
					}
				}
			}
		},
		// Main workhorse. Calculates the "Your Price" after adding any fees and then subtracting any discount associated with the catentryid. Always returns a double
		
		calculateYouPriceV2 : function(catentryid, isBundle,finalprices,discount) {
			CMath.showLocalizedValues($('.online-price[data-catentry='+catentryid+']'), 
					$('.online-price[data-catentry='+catentryid+'] .op-value'),
					$('.online-price[data-catentry='+catentryid+']').data('opvalue'));
			var finalPrice = finalprices-discount; 
			if (!isBundle)  {
				if($('#isBDAppVar').val() == 'BD'){
					$('.your-price .value').text(phelper.formatMoney(phelper.processPrice(finalPrice)));
					if($('.unitcurrency').text() == null || $('.unitcurrency').text() == '$-.- -' || $('.unitcurrency').text().trim() == '' || COSTCO.util.getLocale() == 'fr-CA'){
						$('#price-per-unit-container').addClass('hide');
					}
					else{
						$('#price-per-unit-container').show();
						$('#price-per-unit-container').removeClass('hide');
					}
				}else{
					if(finalPrice!=0.00){
						$('.your-price .value').text(phelper.formatMoney(phelper.processPrice(finalPrice)));
					}
				}
				if($('#isBDAppVar').val() != 'BD') {
					$('#price-per-unit-container').show();
				}
			}
			return finalPrice;
		},
		
		calculateYourPrice : function(catentryid, isBundle) {
			var opPrice;
			if (catentryid) {
				opPrice = COSTCO.util.decode($('.online-price[data-catentry='+catentryid+']').data('opvalue'));
			}
			if($.type(opPrice) === 'string'){
				opPrice = opPrice.split(',').join('');
			}
			var opValue = (parseFloat(opPrice) || 0.00);
			var discount = $('.disc[data-catentry='+catentryid+']').data('disc') 
				? COSTCO.util.decode($('.disc[data-catentry='+catentryid+']').data('disc')) : 0.00
			discount = $.type(discount) === 'string' ? parseFloat(discount.split(',').join('')) : discount;
			var fees = function() {
				var totalFees = 0.00;
				if ($.cookie('C_LOC') !=null){
					if ($.cookie('C_LOC').length>2){
						$('.fees.'+$.cookie('C_LOC')+'[data-catentry='+catentryid+']').each(function() {
							var isFeeCombined = false;
							if(typeof feesCombineWithPrice !== 'undefined'){
								for (var i = 0; i < feesCombineWithPrice.length; i++) {
									var config = feesCombineWithPrice[i];
									if (config.region == $.cookie('C_LOC') && config.feeId == $(this).data('feeid')) {
										isFeeCombined = true;
										opValue += parseFloat(COSTCO.util.decode($(this).data('feeamt')));
										break;
									}
								}
							}
							if(!isFeeCombined){
								totalFees += parseFloat(COSTCO.util.decode($(this).data('feeamt')));
							}
						});
					}
				}
				return totalFees;
			}();
			
			$('.online-price[data-catentry='+catentryid+'] .op-value').text(phelper.formatMoney(phelper.processPrice(opValue)));		        			
			$('.online-price[data-catentry='+catentryid+']').attr('data-opvalue', COSTCO.util.encode(opValue+''));
			
			var finalPrice = (opValue+fees)-discount; 
			if (!isBundle)  {
				if($('#isBDAppVar').val() == 'BD'){
					$('.your-price .value').text(phelper.formatMoney(phelper.processPrice(finalPrice)));
					if($('.unitcurrency').text() == null || $('.unitcurrency').text() == '$-.- -' || $('.unitcurrency').text().trim() == '' || COSTCO.util.getLocale() == 'fr-CA'){
						$('#price-per-unit-container').addClass('hide');
					}
					else{
						$('#price-per-unit-container').show();
						$('#price-per-unit-container').removeClass('hide');
					}
				}else{
					if(finalPrice!=0.00){
						$('.your-price .value').text(phelper.formatMoney(phelper.processPrice(finalPrice)));
					}
				}
				if($('#isBDAppVar').val() != 'BD') {
					$('#price-per-unit-container').show();
				}
			}
			return finalPrice;
		},
		// Generic utility function for hiding the passed element. Additionally, this function encodes the hidden values to base64
		hideElements : function(element, valueHolder) {
			$(element).each(function() { 
				if (!$(this).hasClass('hide')){ $(this).addClass('hide'); }
				if ($(this).hasClass('active')){ $(this).removeClass('active'); }
			});
			$(valueHolder).each(function() { 
				if (!COSTCO.util.base64test.test($(this).text())) {
					$(this).text(COSTCO.util.encode($(this).text()))
				}
			})
		},
		// Hides price per unit container
		hidePricerPerUnit : function() {
			if(products[0].length > 1) {
				$('#price-per-unit-container').hide();
			}
		},
		// Generic utility function for showing the localized values of valueHolder.
		showLocalizedValues : function(parent, valueHolder, value){
			$(parent).toggleClass('hide'); $(parent).toggleClass('active');
			if($('#isBDAppVar').val() == 'BD'){
				$(valueHolder).text(phelper.formatMoney(phelper.processPrice(value)));
			}else{
				if(phelper.processPrice(value)!=0.00){
					$(valueHolder).text(phelper.formatMoney(phelper.processPrice(value)));
				}else{
					$(valueHolder).text('--');	
				}
			}
		},
		// Show the math table breakdown (true/false). True is show, false is hide.
		showBreakdown : function(flag,catentryId) {
			if (flag) {
				var sameVals = $('.active.online-price .op-value').text()==$('.your-price .value').text() 
				if ($('#breakdown').hasClass('hide') && !sameVals  && $('.active.online-price .op-value').text() != "--") {
					$('#breakdown').toggleClass('hide active');
				} else if ($('#breakdown').hasClass('active') && sameVals) {
					$('#breakdown').toggleClass('active hide');
				}
			} else { 
				if ($('#breakdown').hasClass('active')) { 
                    $('#breakdown').toggleClass('active hide');
                    if($('#isBDAppVar').val() != 'BD'){
                        $('.your-price .value').text('--');
                        CMath.hidePricerPerUnit();
                    }
                }
			}
		},
		/**
		 * Uses feesCombineWithPrice config set from xappconfig to determine if
		 * eco-fee should be hidden and included in the online-price
		 */
		useRegionFeeIncludedOpValue : function(parent, catentryid) {
			function getRegionPrice(regionPrices, region) {
				for (var i = 0; i < regionPrices.length; i++) {
					if (regionPrices[i].region == region) {
						return regionPrices[i].price;
					}
				}
				return null;
			}
			function getFeeId(feeOptions, region) {
				for (var i = 0; i < feeOptions.length; i++) {
					if (feeOptions[i].region == region) {
						return feeOptions[i].feeId;
					}
				}
				return null;
			}
			
			function getFeeIds(feeOptions, region) {
				var feeIds =[];
				for (var i = 0; i < feeOptions.length; i++) {
					if (feeOptions[i].region == region) {
						feeIds.push(feeOptions[i].feeId);
					}
				}
				return feeIds;
			}
			var region = COSTCO.util.getRegion();
			if (region && region !='""' && $('.fees.'+region).length > 0 && typeof feesCombineWithPrice != 'undefined') {
				var productData = phelper.findItem(products[0], catentryid) || [];
				var feeIds = getFeeIds(productData.feeOptions, region);
				var isAllFeesCombined = false;
				if (feeIds && feeIds.length >0) {
					feeIds.forEach(function(feeId){
						var isFeeCombined =  false;					
						for (var i = 0; i < feesCombineWithPrice.length; i++) {
							var config = feesCombineWithPrice[i];
							if (config.region == region && config.feeId == feeId) {
								isFeeCombined = true;
								break;
							}
						}
						isAllFeesCombined = isAllFeesCombined && isFeeCombined;
					});
					if(isAllFeesCombined == true){
						hideBreakdownvariants = true;
					}
				}
			}
		},
		/* Product Options (variants) controller */
		bindQuantitiesForBundle : function() {
			var $qtys = $('input[name^=quantity-]'),
				has_math_table = $('.math-table').length > 0;
			$qtys.unbind('change.bundleQty').on('change.bundleQty', function (){
				var total = 0.00, allQtyVals = $.map($qtys,function(e){ var qtyVal = parseInt($(e).val()); return isNaN(qtyVal) ? 0 : qtyVal })
				if (has_math_table) {
					$qtys.each(function(i) {
						var qtyVal = parseInt($(this).val()), 
							quantity = isNaN(qtyVal)||qtyVal<0 ?0:qtyVal, //if product is not a number or negative treat as 0
							catentryid = CMath.getCatEntryId($(this).data('product')); 
						typeof catentryid !== 'undefined' 
							? total += (CMath.calculateYourPrice(catentryid,true)*quantity)
							: allQtyVals[i]=0;
						if ( costcoStoreFeatures.WEBSITE_REDESIGN_V2_CART_FEATURE_ENABLE === true ) {
							let itemTotal = CMath.calculateYourPrice(catentryid,true)*quantity;
							let itemProcesPrice = phelper.processPrice(itemTotal);
							let itemFormatMoney = COSTCO.util.formatMoney(itemProcesPrice, true);
							$('#bundle-' + this.id).closest('.bundle-item').find('.bundle-item-total').text(itemFormatMoney);
						}
					});
				}
				//treat quantity value that is negative as 0
				if (COSTCO.util.all(allQtyVals, function(x){ return x==0||x<0 })) {
					CMath.addToCartSwitch(false);
					$('.your-price .value').text('--');
					CMath.hidePricerPerUnit();
				} else {
					CMath.addToCartSwitch(true);
					if (has_math_table) {
						$('.your-price .value').text(COSTCO.util.formatMoney(phelper.processPrice(total)),true);
					}
				} 
			})
		},
		/**
	     * Updates item number section for Bundle without variance.
	     * @return void
	     */
		updateItemNumberDisplay : function() {
			$('#product-body-item-number').html(messages.PDETAIL_NUMBER + products[0][0].partNumber);
			$('#product-body-item-number').removeClass('hide');
		},
		// Each variant select associated with a product gets a change event that controls if to calculate a price (i.e. if there are any unselected values as part of a multi-variant product). Handles bundles
		  bindVariantProducts: function bindVariantProducts(type, inOption) {

			  if (typeof inOption !== 'undefined'){
				  $('.varis').find('option[value=' + inOption + ']').prop('selected', true);
			  }
			$('.varis').each(function(variIndex) {
				if(variIndex + 1 == $('.varis').length && ((!costcoStoreFeatures.WEBSITE_REDESIGN_V2_PDP_FEATURE_ENABLE && COSTCO.Product.sortVariantOptions) || (costcoStoreFeatures.WEBSITE_REDESIGN_V2_PDP_FEATURE_ENABLE) )){
					console.log("Binding the Variants Selected ");
					COSTCO.CMath.allVariantsSelected = true;
				}
				$(this).parent().find('select[data-product='+$(this).data('product')+']').unbind('change.vari').on('change.vari', function(){
					var num = $(this).data('product');
					var variantProductIndex = $(this).index('.varis[data-product='+num+']');
					let optionsSelected = phelper.get_selected_array($('.varis[data-product='+num+']').find('option:selected'));
					if( isPDPVariantGreyOutEnabled == 'true'){
												//Analytics for variants
					 for(var i=0;i<optionsSelected.length;i++){

						 var $selectedOption = $('.varis option[value=' + optionsSelected[i] + ']');
						 var productOptionId = $selectedOption.parent().attr('id');
						 var $selectedOptionLabel = $('label[for=' + productOptionId + ']');
						 var $selectedOptionKey = $selectedOptionLabel.find('.selectedOptionKey');
						 var $selectedOptionValue = $selectedOptionLabel.find('.selectedOptionValue');
						 var selectedlabelText=$selectedOptionKey.text().split(':')[0].trim();
						 window.digitalDataEvents = window.digitalDataEvents || [];
						 var swatch=$('#swatches-productOption0'+parseInt(optionsSelected.length-1)+'').length > 0 ;
						 var dropDown=$('.varis-v2[automation-id=varisSwatch_0'+parseInt(optionsSelected.length-1)+']').length>0 ;
						 if(swatch){
							 var swatchvalue=$('span[automation-id=selectionItem_'+optionsSelected[i]+']').text().trim();
							 digitalDataEvents.push( { uimsg:"Product Detail | "+selectedlabelText+" | "+swatchvalue+"" } );
						 }else if(dropDown){
							 var dropdownvalue= $('.varis-v2 option[automation-id=varisOption_' + optionsSelected[i] + ']').text().trim();
							 if(!dropdownvalue.includes(messages.PDETAIL_IMAGE_OUT_OF_STOCK_ALT)){
								 digitalDataEvents.push( { uimsg:"Product Detail | "+selectedlabelText+" | "+dropdownvalue+"" } );
							 }
						 }
					 }
					}
						if(!COSTCO.CMath.pdpPageloadComplete && !COSTCO.CMath.iskitsbundle){// inorder to handle multivariant 3 level on page load this iteration is required for enabling lower level
							for(var i=0;i<optionsSelected.length-1;i++){
								CMath.next_variant_attributes(i, num, optionsSelected[i]);
							}
						}else{
							if(!COSTCO.CMath.iskitsbundle || (COSTCO.CMath.iskitsbundle && !dropDown ) ){
								CMath.next_variant_attributes(variantProductIndex, num, $(this).find('option:selected').val());
							}
							
						}
					
					optionsSelected = phelper.get_selected_array($('.varis[data-product='+num+']').find('option:selected'));
					let any_unselected = optionsSelected.indexOf("unselected") > -1;
					let any_selected = COSTCO.util.any(optionsSelected,function(x){return x!="unselected"});
					var selectedCatentryid = CMath.getCatEntryId(num,optionsSelected);
					var selectedProgramType = CMath.getItemProgramType(num,optionsSelected);
					var isShipToWarehouseItem = CMath.isShipToWarehouseItem(num,optionsSelected);
					var applType = $('#applicationType').val();
					CMath.disableSelectsAfterUnselected($('.varis[data-product='+num+']').parent(),optionsSelected,type);
					if( applType=='BC') {
						var varaintParameters = {"productId":selectedCatentryid,"programType":selectedProgramType, "storeId":wcs.storeId};
						if(selectedCatentryid != undefined && selectedProgramType != undefined){
							if(typeof selectedObj === undefined || JSON.stringify(selectedObj)!== JSON.stringify(varaintParameters)){
								selectedObj = varaintParameters;
								window.reactObj.global.shipToWarehouse = isShipToWarehouseItem;
								window.reactObj.fulfillments.buyInStoreOnly.productId = selectedCatentryid;
								window.reactObj.fulfillments.buyInStoreOnly.programType = selectedProgramType;
								if(phelper.item_type == 'single_variant' ||phelper.item_type == 'multi_variant'){
									window.reactObj.fulfillments.buyInStoreOnly.wcsVariant =true;
									window.reactObj.fulfillments.buyInStoreOnly.readInvFromBatchApi =false;
									var readInvFromBatchApiXapp = $('#readInvFromBatchApiEnabled').val();
									if(readInvFromBatchApiXapp === 'true'){
										window.reactObj.fulfillments.buyInStoreOnly.readInvFromBatchApi = true;
									}
								}
								try {
									if(typeof window.reactObj.fulfillments.buyInStoreOnly != undefined) {
										if(typeof window.reactObj.fulfillments.buyInStoreOnly.readInvFromBatchApi != undefined 
												&& window.reactObj.fulfillments.buyInStoreOnly.readInvFromBatchApi){
											window.wioEventBus.publish('notifyVaraintsChange',varaintParameters);
										} else {
											var itemStockStatusExist = false;
											var selectedPartNum = '';
											$.each(products, function(index,jsonObject){
												$.each(jsonObject, function(key, value){
													if(value['catentry'] === selectedCatentryid){
														selectedPartNum = value['partNumber'];
													}
												});
											});
											$.each(COSTCO.CMath.varItemJSON, function(index,jsonObject){
												$.each(jsonObject, function(key, value){
													$.each(value, function(objKey, objValue){
														if(objKey === 'itemNumber' && objValue === selectedPartNum) {
															itemStockStatusExist = true;  // verify if selected item stock exists
														}
													});
												});
											});
											if(itemStockStatusExist){
												window.wioEventBus.publish('notifyVaraintsChange',varaintParameters);
											}
										}
									}
								} catch(e) {
									console.log(e);
								}
							}
						}
					}
					
					let preselectAttrsStr = COSTCO.util.getParameterByName('preselect');
					if(typeof preselectAttrsStr !== 'undefined' && preselectAttrsStr != null && preselectAttrsStr != 'null' && CMath.preSelectedAttributesChanged == false){
						let preselectAttrArr = preselectAttrsStr.split('||');
						CMath.preSelectedAttributesPassed = true;
						if(preselectAttrArr.length == 1){
							preselectAttrKeyVal = preselectAttrArr[0];
							let replaceSelected = '';
							let replaceNextVariant = '';
							let preselectAttrKeyValArr = preselectAttrKeyVal.split(':');
							optionsSelected.forEach(function(selectedOption, selectedIndex){
								options[0].forEach(function(optionsArr){
									if(optionsArr['n'].toLowerCase() == preselectAttrKeyValArr[0]){
										if(optionsArr['v'].hasOwnProperty(selectedOption) == true ){
											Object.keys(optionsArr['v']).forEach(function(attrVal) {
												if(optionsArr['v'][attrVal].toLowerCase() == preselectAttrKeyValArr[1] && attrVal.toLowerCase() == selectedOption){
													console.log(preselectAttrKeyValArr[1] + " value is preselected ");
												} else if(optionsArr['v'][attrVal].toLowerCase() == preselectAttrKeyValArr[1]){
													replaceSelected = attrVal;
													console.log(preselectAttrKeyValArr[1] + " new value is preselected " + attrVal);
												}
											});
											if(replaceSelected !== ''){
												optionsSelected.splice(optionsSelected.indexOf(selectedOption), 1, replaceSelected)
												$('.varis').find('option[value=' + replaceSelected + ']').prop('selected', true);
												
												var nextSelectedIndex = selectedIndex == 0 ? 1 : 0 ;
												products[0].forEach(function(product, index){
													if(product.options.includes(replaceSelected) == true){
														
														if(product.options.includes(optionsSelected[nextSelectedIndex]) == true){
															console.log("The Variant Exists .. ");
															replaceNextVariant = optionsSelected[nextSelectedIndex];
														} else {
															if(replaceNextVariant == ''){
																replaceNextVariant = product.options[0] == replaceSelected ? product.options[1] : product.options[0];
															}
														} 
													}
												});
												if(typeof(replaceNextVariant) != 'undefined' && replaceNextVariant != ''){
													optionsSelected.splice(nextSelectedIndex, 1, replaceNextVariant)
													$('.varis').find('option[value=' + replaceNextVariant + ']').prop('selected', true);
												}
												CMath.next_variant_attributes(variantProductIndex, num, replaceSelected);
												replaceSelected = '';
												replaceNextVariant = '';
											}
										}
									}
								});
							});
							
						} else {	
							preselectAttrArr.forEach(function(preselectAttrKeyVal, index) {
								let replaceSelected = '';
								let preselectAttrKeyValArr = preselectAttrKeyVal.split(':');
								optionsSelected.forEach(function(selectedOption, selectedIndex){
									options[0].forEach(function(optionsArr){
										if(optionsArr['n'].toLowerCase() == preselectAttrKeyValArr[0]){
											if(optionsArr['v'].hasOwnProperty(selectedOption) == true ){
												Object.keys(optionsArr['v']).forEach(function(attrVal) {
													if(optionsArr['v'][attrVal].toLowerCase() == preselectAttrKeyValArr[1] && attrVal.toLowerCase() == selectedOption){
														console.log(preselectAttrKeyValArr[1] + " value is preselected ");
													} else if(optionsArr['v'][attrVal].toLowerCase() == preselectAttrKeyValArr[1]){
														replaceSelected = attrVal;
														console.log(preselectAttrKeyValArr[1] + " new value is preselected " + attrVal);
													}
												});
												if(replaceSelected !== ''){
													optionsSelected.splice(optionsSelected.indexOf(selectedOption), 1, replaceSelected)
													$('.varis').find('option[value=' + replaceSelected + ']').prop('selected', true);
													replaceSelected = '';
												}
											}
										}
									});
								});
								
							});
						}
						CMath.preSelectedAttributesChanged = true;
						$('body').trigger("costco.variant.changed");
					}
					
					if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_PDP_FEATURE_ENABLE &&
							!$(optionsSelected).parents('.vari').is('.swatchDropdown[data-swatch-mode=2]')) {
							
						optionsSelected.forEach(function(value) {
							CMath.update_selected_option_label(value);
						});
						CMath.disableSelectsAfterUnselected($('.varis-v2[data-product='+num+']').parent(),optionsSelected,type);
						try{
							
							for(var i = $('.varis[data-product=0]').length-1; i > 0 ; i--) {
								$("#productOption0"+i+" option[style*='display: none']").each(function(){
									$("#swatches-productOption0"+i+" input[value*='"+$(this).val()+"']").parent().hide();
									$(this).attr('disabled', 'disabled').hide();
								 });


								$("#productOption0"+i+" option[style*='display: block'], #productOption0"+i+" option[style*='display: inline']").each(function(){
									if($("#swatches-productOption0"+i+" input:checked:enabled").length <1){
										$("#swatches-productOption0"+i+" input[value*='"+$(this).val()+"']").click();
										$(this).removeAttr('disabled').show();
										return false;
									}
								});
							}
	
						}catch(e){
							console.log(e);
						}

					}
							
					if (type==='bundle') {
						// If we're a bundle and at least one variant is selected and its associated qty
						// is 0, set it to one to help user.
						if (any_selected) { 
							var $input = $(this).parents('.variantContainer').find('.bundleQty input'),
								input_val = $input.val();
							if (!isNaN(parseInt(input_val)) && parseInt(input_val) ==0) {
								$input.val(1);
							}
						}
						$('input[name^=quantity-]').trigger('change.bundleQty');
					} 
					if (type !=='bundle' && any_unselected) {
						CMath.showLowestPriceVariant();
						//if the catentryid is undefined it means there is no option selected
						//in that case show default variant backorder message 
						if (typeof catentryid === "undefined") {
							$('#backorder-message').text(variantBackorderMessageDefault);
							$('#backorder-message').show();
						}
					} else {
						$('.starting-price').hide();
					}
					
					let catentryid = CMath.getCatEntryId(num,optionsSelected);
					if(product[0].isScheduledDeliverable === "true" && catentryid){ //invoke if item is scheduledDeliverable and a variant has been selected
						window.COSTCO.ScheduledDeliverable.setDeliverableInputsFromSelectedProduct();
					}
					let variantIndex = 0;
					let deliveryVendorSku = '';
					COSTCO.Product.active_catentry = catentryid;
					//populate the catalogEntryID property in the add to cart form with the 
					//catentry ID for the resolved item.
					if (typeof catentryid !== "undefined") {
						COSTCO.CMath.allVariantsSelected = true;
						if (type==='bundle') { 
							$('input[name=catalogEntryId_'+(num+1)+']').val(catentryid);
							
						} else { 
							//exclude the contract specific flow as price will be populated by ajax in that flow
							$('input[name=catEntryId]').val(catentryid);
							if( $('#isBDAppVar').val() == 'BD') {
								CMath.pricingInfo(catentryid);								
								$('.unitcurrency').text('$' + phelper.formatMoney(phelper.processPrice(phelper.findItem(products[num], optionsSelected).pricePerUnit)));
								if($('.unitcurrency').text() == null || $('.unitcurrency').text() == '$-.- -' || $('.unitcurrency').text().trim() == '' || COSTCO.util.getLocale() == 'fr-CA'){
									$('#price-per-unit-container').addClass('hide');
								}
								else{
									$('#price-per-unit-container').show();
									$('#price-per-unit-container').removeClass('hide');
								}
								CMath.showBreakdown(true);
							}
							//Exclude LocationControlled Inv items
							if (!COSTCO.util.islocationControlledInventoryFlow() && $('#isBDAppVar').val() == 'BD')	{						
								//show backorder message only on variants that are backorder and hide for the rest
								let variantInventory = phelper.findItem(products[num], optionsSelected).inventory;
								let vaiantType = phelper.findItem(products[num], optionsSelected).type;
								if((variantInventory && variantInventory === COSTCO.util.productConstants.inv_backorderd) || vaiantType > 2) {
									$('#backorder-message').text(phelper.findItem(products[num], optionsSelected).backorderMessage);
									$('#backorder-message').show();
									$('.edd-container').hide();
								} else {
									$('#backorder-message').hide();
									$('.edd-container').show();
								}
							}
							
							for(var i = 0; i < products[0].length; i++) {
								if(products[0][i].catentry === catentryid) {
									variantIndex = i;
									break;
								}                           
							}
							
						}
					}else {
						//Only 1 attribute is selected from multi-variant
						COSTCO.CMath.allVariantsSelected = false;
						for(var i = 0; i < products[0].length; i++) {
							if(products[0][i].options[0] === optionsSelected[0] || products[0][i].options[1] === optionsSelected[0]) {
								variantIndex = i;
								break;
							}                           
						}
						
					}
					for(var i = 0; i < products[0].length; i++) {
						if(products[0][i].inventory !== COSTCO.util.productConstants.inv_outOfStock) {
							deliveryVendorSku = deliveryVendorSku + products[0][i].manufacturerPartNumber + ",";
						}                           
					}
					if(deliveryVendorSku.length > 0){
						deliveryVendorSku = deliveryVendorSku.slice(0,deliveryVendorSku.length-1);
					}
					
					if (any_selected){
						if ($(window).width() < 769) {
							$('.item-model-number').removeClass('col-xs-12');
							//STR0167115 - ALM26087
							//and STRY0167115...
							if (products[0] !== undefined && products[0][variantIndex] !== undefined && products[0][variantIndex].vendorModelNumber !== undefined && products[0][variantIndex].vendorModelNumber !== "") {
								if (messages !== undefined && messages.PDETAIL_MODEL !== undefined) {
									$('#model-no').html(messages.PDETAIL_MODEL + products[0][variantIndex].vendorModelNumber);
								} else {
									$('#model-no').html(products[0][variantIndex].vendorModelNumber);
								}
							}
						}
						else {
							
							//STRY0167115...
							if (products[0] !== undefined && products[0][variantIndex] !== undefined && products[0][variantIndex].partNumber !== undefined && products[0][variantIndex].partNumber !== "") {
								if (messages !== undefined && messages.PDETAIL_NUMBER !== undefined) {
									$('#product-body-item-number').html(messages.PDETAIL_NUMBER + products[0][variantIndex].partNumber);
								} else {
									$('#product-body-item-number').html(products[0][variantIndex].partNumber);
								}
							}
							$('#product-body-item-number').removeClass('hide');
							if(COSTCO.CMath.iskitsbundle){
								if (products[0] !== undefined && products[0][variantIndex] !== undefined && products[0][variantIndex].productName !== undefined && products[0][variantIndex].productName !== "") {
									$('[automation-id="productName"]').text(products[0][variantIndex].productName);   
								}
							}
							//STR0167115 - ALM26087
							//and STRY0167115...
							if (products[0] !== undefined && products[0][variantIndex] !== undefined && products[0][variantIndex].vendorModelNumber !== undefined && products[0][variantIndex].vendorModelNumber !== "") {
								if (messages !== undefined && messages.PDETAIL_MODEL !== undefined) {
									$('#product-body-model-number').html(messages.PDETAIL_MODEL + products[0][variantIndex].vendorModelNumber);
								} else {
									$('#product-body-model-number').html(products[0][variantIndex].vendorModelNumber);
								}
							}
						}
						
						$('#showLiveEDD').val(products[0][variantIndex].eddVendorName);
						$('#vendorName').val(products[0][variantIndex].eddVendorName);
						
						var defaultShipcode = "";	

						if ($('#defaultShipcode').length != 0) {
							defaultShipcode=$('#defaultShipCode').val();
						} 

						if (!COSTCO.util.isEDDEnabled() || !CMath.isValidShipMode(defaultShipcode)) {
							$('#showLiveEDD').val("");
							$('#vendorName').val("");
						}
						if(((isRegionalPdtAvlble || !COSTCO.util.issiteControlledInventoryFlow()) && initalizeAjaxCall)
								||$('#isBDAppVar').val() == 'BD' || ((phelper.item_type == 'single_variant' ||phelper.item_type == 'multi_variant')
								&& !initalizeAjaxCall) && !COSTCO.CMath.iskitsbundle){
                            CMath.handleEDDForms();
                        }
						
						if (messages !== undefined && messages.PDETAIL_NUMBER !== undefined) {
							$('#item-no').html(messages.PDETAIL_NUMBER + products[0][variantIndex].partNumber);
						} else {
							$('#item-no').html(products[0][variantIndex].partNumber);
						}							
						
						COSTCO.Header.itemPartNumberSelcted = products[0][variantIndex].partNumber;
						
						// update sku/itemNumber for analytics
						
						window.digitalDataEvents = window.digitalDataEvents || [];
						if(typeof window.digitalData !== "undefined" && typeof window.digitalData.product !== "undefined" && typeof window.digitalData.product[0] !== "undefined") {
							window.digitalData.product[0].sku = products[0][variantIndex].partNumber;
							window.digitalData.product[0].itemNumber = products[0][variantIndex].partNumber;
						}

					}	
					if(product[0].isScheduledDeliverable === "true"){ //invoke if item is scheduledDeliverable and a variant has been selected
						
						$('#deliveryVendorSku').val(products[0][variantIndex].manufacturerPartNumber);
						$('#deliveryVendorSkuArr').val(deliveryVendorSku);
						
						//attach event to select options button
						window.COSTCO.ScheduledDeliverable.attachEventSelectOptions({
		                  sku: $('#deliveryVendorSku').val(),
		                  categoryCode:$('#categoryCode').val(),
		                  zipCode: $('#delivery-zip').val()
		                  
		                });
						let swatchMode = $('.swatchDropdown').data('swatch-mode');
						
						if($('#catEntryId').val() == COSTCO.Product.active_catentry && (previousContractAjaxItem != COSTCO.Header.itemPartNumberSelcted ) 
								&& ((swatchMode == 2 &&(brandfolderEnabled || (COSTCO.CMath.swatchTileSelected && COSTCO.CMath.swatchInitialTileSelected))) || 
						((swatchMode == 1 || swatchMode == 0) && !costcoStoreFeatures.WEBSITE_REDESIGN_V2_PDP_FEATURE_ENABLE && COSTCO.Product.sortVariantOptions) || 
						((swatchMode == 1 || swatchMode == 0) && costcoStoreFeatures.WEBSITE_REDESIGN_V2_PDP_FEATURE_ENABLE && COSTCO.Product.sortVariantOptions_V2))) {
							previousContractAjaxItem = COSTCO.Header.itemPartNumberSelcted;
							if(products[0][variantIndex].zipcodeAvailabilityMessage === '0' || typeof(products[0][variantIndex].zipcodeAvailabilityMessage) === "undefined"){
								window.COSTCO.ScheduledDeliverable.resetDeliverableForm();
								var url = "AjaxDeliveryReservationCalendarCmd?storeId="+wcs.storeId+"&deliveryVendorSku=" + $('#deliveryVendorSku').val() + "&zipCode=" + $.cookie('invCheckPostalCode') + "&productSku=" + $('#productPartnumberVal').val();
								COSTCO.ScheduledDeliverable.submitDeliverableAvailabilityAjax({
					                sku: $('#deliveryVendorSku').val(),
					                url: url,
					                productSku : $('#productPartnumberVal').val(),
					                zipCode: $.cookie('invCheckPostalCode')
					            });
							} else if(typeof(products[0][variantIndex].zipcodeAvailabilityResponseCode) !== "undefined" && products[0][variantIndex].zipcodeAvailabilityResponseCode === COSTCO.util.productConstants.zipcodeAvailCheck_StatusFail){
								if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_PDP_FEATURE_ENABLE) {
									$('#deliveryFailMessage').removeClass("hide");
									$('#prod-page-delivery').removeClass('hide');
									$('#zip-group').addClass('hide');
									if(products[0][variantIndex].zipcodeAvailabilityMessageCode === COSTCO.util.productConstants.inv_backorderd){
										$('#deliveryFailMessage').addClass("warning").removeClass("critical-notification");
										$('[name=select-options]').prop("disabled", false);
									} else {
										$('#deliveryFailMessage').removeClass("warning").addClass("critical-notification");
										$('[name=select-options]').prop("disabled", true);
									}
									$('#geDeliveryFailMessageSpan').text(products[0][variantIndex].zipcodeAvailabilityMessage);
									$('#deliveryDateMessage').removeClass('success').addClass('hide');
						            $('#deliveryLocationText').addClass('hide');
						            $('#deliveryInfoText').addClass("hide");
								}else {
									$('#deliveryFailMessage').removeClass("hide");
									$('#prod-page-delivery').addClass('hide');
									$('#zip-group').addClass('hide');
						            $('#geDeliveryFailMessageSpan').text(products[0][variantIndex].zipcodeAvailabilityMessage);
									$('#deliveryDateMessage').removeClass('success').addClass('hide');
						            $('#deliveryLocationText').addClass('hide');
						            $('#deliveryInfoText').addClass("hide");
						            if(products[0][variantIndex].zipcodeAvailabilityMessageCode === COSTCO.util.productConstants.inv_backorderd){
										$('[name=select-options]').prop("disabled", false);
									} else {
										$('[name=select-options]').prop("disabled", true);
									}
								}
							} else {
								if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_PDP_FEATURE_ENABLE) {
									let deliveryDate = products[0][variantIndex].zipcodeAvailabilityMessage;
									let date = deliveryDate ? new Date(deliveryDate).toLocaleDateString('en-US', {weekday: 'long', month : 'long', day:'numeric'}) : "";
									$('#deliveryDateMessageTxt').text(date);
								} else {
									$('#deliveryDateMessageTxt').text(products[0][variantIndex].zipcodeAvailabilityMessage);
					            }
								$('#zip-group').removeClass('hide');
								$('#deliveryFailMessage').addClass("hide");
					            $('#prod-page-delivery').addClass('hide');
					            $('#deliveryDateMessage').removeClass('hide').addClass('success');
					            $('#deliveryLocationText').removeClass('hide');
					            $('#deliveryInfoText').removeClass("hide");
							}
						}
					}
					if($(this).parents('.vari').is('.swatchDropdown[data-swatch-mode=1]')){
						var swatchable = $(this).find('option:selected[data-swatch]');
						if(swatchable.length > 0){
							CMath.triggerSwatchDropDownSelection($(swatchable).data('swatch'));
						}
					}

					if (any_selected && (typeof catentryid !== "undefined" || !catentryid)&& COSTCO.CMath.allVariantsSelected) {
						$('body').trigger("costco.variant.changed");	
						let swatchMode = $('.swatchDropdown').data('swatch-mode');
						if($('#catEntryId').val() == COSTCO.Product.active_catentry && 
								((swatchMode == 2 &&(brandfolderEnabled || (COSTCO.CMath.swatchTileSelected && COSTCO.CMath.swatchInitialTileSelected))) || 
						((swatchMode == 1 || swatchMode == 0) && !costcoStoreFeatures.WEBSITE_REDESIGN_V2_PDP_FEATURE_ENABLE && COSTCO.Product.sortVariantOptions) || 
						((swatchMode == 1 || swatchMode == 0) && costcoStoreFeatures.WEBSITE_REDESIGN_V2_PDP_FEATURE_ENABLE && COSTCO.Product.sortVariantOptions_V2)) ){
							if ($.cookie('invCheckPostalCode') != null && $('#liveEDD') && $('#liveEDD').val() === "true" && !$('#vendorName').val().toLowerCase().includes('narvar') && $('#edd-form-block').length > 0) {
								if( typeof selectedVar === undefined || selectedVar != $('#catEntryId').val()){
									selectedVar = $('#catEntryId').val();
									COSTCO.Product.displayEDDForm = false;
									COSTCO.Product.retrieveEDD();
									COSTCO.Product.isEddItem = true;
								}
							} else if($('#productPage').val() && $('#liveEDD') && $('#liveEDD').val() === "true" && $('#vendorName').val().toLowerCase().includes('narvar') && $('.edd-container').length > 0){
								COSTCO.CMath.callEDDFunctions();
							}
						}
					} 
					
					if ((!(any_selected && (typeof catentryid !== "undefined" || !catentryid)) || (typeof($.cookie('invCheckPostalCode')) === 'undefined' || $.cookie('invCheckPostalCode') == null)) 
							&& $('#edd-form-block').length > 0 && !$('#vendorName').val().toLowerCase().includes('narvar') ) {
							COSTCO.Product.showEddForm();
					}
					//block ajax calls which are repeated and in case of variation only trigger ajax after its first call from init 
					if(($('.swatchDropdown').data('swatch-mode') == 2 && 
							(!COSTCO.CMath.swatchTileSelected || (COSTCO.CMath.swatchTileSelected && previousContractAjaxItem === '')))) {
						brandfolderEnabled ? blockContractAjax=false : blockContractAjax=true;
					} else {
						blockContractAjax = false;
					}
					var userInfo = COSTCO.util.getMemberCookie(), signedIn = userInfo.signedIn, costcoMember = userInfo.costcoMember != 'undefined' ? userInfo.costcoMember : false,
							memberOnly =  $('#memberItem').val()=="true"? true:false; 
					var itemPartNumber = COSTCO.Product.getPartnumber();
					
					varaintParameters = {"productId":selectedCatentryid,"programType":selectedProgramType,"partNumber":itemPartNumber, "storeId":wcs.storeId};
                    if(isShipToWarehouseItem){
                        window.wioEventBus.publish('notifyVaraintsChangeForSTW',varaintParameters);
                    }
                    
					var scheduledDeliverable = $('#scheduledDeliverable').val()=="true"?true:false;
					//Invoke contract specific ajax on each selection		
					if(!COSTCO.CMath.iskitsbundle){
						if (CMath.changeVariantTriggered && CMath.isContractSpecificAjaxRequired() && selectedCatentryid != undefined ) {
							retryCount=0;
							if(!memberOnly || (signedIn && memberOnly) ) {
									CMath.handleContractSpecificRules();
							}else{
								if( isPDPVariantGreyOutEnabled == 'true' && (!(Array.isArray(product) && product.length && product[0].isComingSoon && comingSoonFeatureFlag) &&  !scheduledDeliverable)){
								COSTCO.CMath.invokeBatchCallForUpperLevel(itemPartNumber);
								COSTCO.CMath.handlePillsForGuest();
								COSTCO.CMath.invokeAjaxCall =false;
								}
							}	
					}else{
						if( isPDPVariantGreyOutEnabled == 'true'&& (!(Array.isArray(product) && product.length && product[0].isComingSoon && comingSoonFeatureFlag) &&  !scheduledDeliverable)){
						COSTCO.CMath.invokeBatchCallForUpperLevel(itemPartNumber);
						COSTCO.CMath.handlePillsForGuest();
						COSTCO.CMath.invokeAjaxCall =false;
						}
					}
					}
					var itemPartNumber = COSTCO.Product.getPartnumber();
					window.reactObj.fulfillments.buyInStoreOnly.partNumber =  itemPartNumber;
					window.eventBus.publish('bfImageViewerPartnumber',itemPartNumber);
					 window.eventBus.publish('pdpSwatchUpdate',itemPartNumber);
					window.eventBus.subscribe('reactReady',() => {
					window.eventBus.publish('bfImageViewerPartnumber',itemPartNumber);
					});
					window.eventBus.subscribe('swatchReady',() => {
					 window.eventBus.publish('pdpSwatchUpdate',itemPartNumber);
					});
					window.reactObj.defaultItemNumber= itemPartNumber;
					if(COSTCO.CMath.iskitsbundle){
                      COSTCO.CMath.invokeBuildABundle(catentryid);
                     }
				});
				
				if (!CMath.changeVariantTriggered) {
					$(this).trigger('change.vari');
					CMath.changeVariantTriggered = true;
				}
			});
			
		},
		//FOr GuestUser, To handle pills selection based on oos response
		handlePillsForGuest: function() {
			let optionsSelected = COSTCO.Product.get_selected_array($('.varis[data-product=0]').find('option:selected'));
  			var len = optionsSelected.length;
			 $('#swatches-productOption0'+parseInt(len-1)+' .selection-box-v2').find('span.selection-item').each(function(){
    	            $(this).removeClass("select-span1-OOS");
    	        });
			 var variable;
      		 var lowerSwatch=$('#swatches-productOption0'+parseInt(len-1)+'').length > 0 ;
				if(lowerSwatch){// pills
    				 if(COSTCO.Product.item_type === 'multi_variant'  ){
        				 
        				 variable= $('input[value=' +optionsSelected[len-1]+ ']').next().attr("automation-id");
        				 
        			 }else if(COSTCO.Product.item_type === 'single_variant'){
        				// $('.selection-item').removeClass("select-span1-OOS");
        				 variable= $('input[value=' +optionsSelected[0]+ ']').next().attr("automation-id");  
        			 }
					  if($('span[automation-id='+variable+']').hasClass('span1-outofstock')) {
						  $('span[automation-id='+variable+']').addClass("select-span1-OOS");
					  }
      			}
      			CMath.update_selected_option_label(optionsSelected[len-1]);
		},
		callEDDFunctions: function() {
			if(COSTCO.Header.narvarDCFetchedSku == '' || COSTCO.Header.narvarDCFetchedSku != COSTCO.Header.itemPartNumberSelcted){
				if (COSTCO.Header.hasInvPostalCodeCookie() && COSTCO.Header.isInvStateCookieMissing()) {
					let zipcode = $.cookie('invCheckPostalCode');
					let updateZipCodeStateCookies = function(data, textstatus, XMLHttpRequest) {
			    					
						let locationData = COSTCO.Header.extractLocationData(data);
						let invalidZip = locationData.InvalidZip;
				    	let province = locationData.Province;
						let country = locationData.Country;
						
			  	  		if(!invalidZip) {
			  	  			COSTCO.Header.setDeliveryCookies(zipcode, province, country);
			  	  			if(COSTCO.Header.narvarDCFetchedSku == '' || COSTCO.Header.narvarDCFetchedSku != COSTCO.Header.itemPartNumberSelcted){
					  	  		COSTCO.Header.startEDDMutationObserver();
				  	  			COSTCO.Header.showEDDWidget();
			  	  			}
			  	  		}
			    	};
			    	if ($('#isGeocodeService').val() != "true") {
			    		COSTCO.util.callBing(zipcode, updateZipCodeStateCookies, updateZipCodeStateCookies);
			    	} else {
			    		COSTCO.util.callGeocodeAPI(zipcode, updateZipCodeStateCookies, updateZipCodeStateCookies);
			    	}
				} else {
					COSTCO.Header.startEDDMutationObserver();
	  	  			COSTCO.Header.showEDDWidget();
				}
			}
			
			
		},
		
		// A utility function that disables successive selects of variant products if their previous is unselected. Supports n multivariants
		disableSelectsAfterUnselected : function(styleSelects,optionsArray,type) {
			
			$(styleSelects).removeClass('disabled');
			$(styleSelects).find('select').removeAttr('disabled');
			var unselectedPos = optionsArray.indexOf("unselected");
			if (type !== 'bundle') {
				if (unselectedPos > -1) {
					CMath.addToCartSwitch(false);
				} else {
					CMath.addToCartSwitch(true);
				}
			}
			for (var i = unselectedPos==-1?optionsArray.length-1:unselectedPos, len = optionsArray.length; i < len; i++) {
				$($(styleSelects)[i+1]).addClass('disabled');
				$($(styleSelects)[i+1]).find('select').attr("disabled","disabled");
				$($(styleSelects)[i+1]).find('option[value=unselected]').prop('selected', true);			
			}
		},		
		
		/**
		 * Utility function that determines what combination of variants is valid
		 * @param  {[type]}
		 * @param  {[type]}
		 * @param  {[type]}
		 * @return {[type]}
		 */
		next_variant_attributes : function(current_index, product_num, prev_variant_value) {
			var $next_variant = $($('.varis[data-product='+product_num+']')[current_index+1]);
			let optionsSelected = phelper.get_selected_array($('.varis[data-product='+product_num+']').find('option:selected'));
			var upperVariant = (optionsSelected.length > 2) ? optionsSelected[0] :'';
			if ($next_variant.length > 0) {
				
				var $next_variant_options = $next_variant.find('option:not(.defaultOpt)');
				
				let $variant_option_input;
				let $variant_option_label;
				let $variant_option_dropbox;
				
				$('.varis-v2').attr('disabled', 'disabled');
				$next_variant_options.attr('disabled', 'disabled').hide().each(function(index, opt) {
					
					if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_PDP_FEATURE_ENABLE) {
						
						if (numberOfOptionsToDisplayAsTiles && $next_variant_options.length < numberOfOptionsToDisplayAsTiles) {
							
							$variant_option_input = $('input[value=' + opt.value + ']');
							$variant_option_label = $variant_option_input.closest('label');
							$variant_option_input.attr('disabled', 'disabled');
							$variant_option_input.prop('checked', false);
						} else {

							$variant_option_dropbox = $('.varis-v2').find('option[value=' + opt.value + ']');
							$variant_option_dropbox.attr('disabled', 'disabled').hide();
							
						}
						 
			        }
					
					products[product_num].forEach(function(product_obj) {
						var upperlevelCheck = (upperVariant != '') ? COSTCO.util.hasElem(upperVariant, product_obj.options) : true;
						if (COSTCO.util.hasElem(prev_variant_value, product_obj.options) && COSTCO.util.hasElem(opt.value, product_obj.options) && upperlevelCheck) {
							
							$(opt).removeAttr('disabled').attr( "style", "display: block;" );
							$(opt)[0].disabled = false;
							
							if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_PDP_FEATURE_ENABLE) {
								
								if (numberOfOptionsToDisplayAsTiles && $next_variant_options.length < numberOfOptionsToDisplayAsTiles) {
									
									$variant_option_label.removeClass('disabled');
									$variant_option_label.show();
									$variant_option_label.css('display','');
									$variant_option_input.removeAttr('disabled');
									if ($variant_option_input.siblings()[0]) {
										CMath.update_variant_option($variant_option_input.siblings(), product_obj, $next_variant_options.length );
									}
								} else {
									
									$variant_option_dropbox.removeAttr('disabled').show();
									if ($variant_option_dropbox[0]) {
										CMath.update_variant_option($variant_option_dropbox[0], product_obj, $next_variant_options.length );
									}
								}
					        }
							
						}
						if(typeof(prev_variant_value) === "undefined" || prev_variant_value == null || product_obj.options.includes(prev_variant_value)){
							CMath.update_variant_option(opt, product_obj, $next_variant_options.length );
						}
					});
				});
				$next_variant.find('option[value=unselected]').prop('selected', true);
				if($next_variant.find('option:enabled').length > 0 && !costcoStoreFeatures.WEBSITE_REDESIGN_V2_PDP_FEATURE_ENABLE ){
					$($next_variant.find('option:enabled')[0]).prop('selected', true) ;
				}
				if ($variant_option_dropbox) {
					let dropdownIndex = current_index+1;
					newoptval = $($('.varis-v2[name=productOption0'+dropdownIndex+']').find('option:enabled')[0]).val();
					$($('.varis-v2[name=productOption0'+dropdownIndex+']').find('option:enabled')[0]).prop('selected', true) ;
					$($($next_variant.find('option[value=' + newoptval + ']'))[0]).prop('selected', true) ;
				}		
			} else if(typeof(prev_variant_value) === "undefined" || prev_variant_value == null){
				var $variant_options = $('.varis[data-product='+product_num+']').find('option:not(.defaultOpt)');
				$variant_options.each(function(index, opt) {
					products[product_num].forEach(function(product_obj) {
						CMath.update_variant_option(opt, product_obj, $variant_options.length );
					});
				});
			}
		},
		
		/**
		 * Function that updates variant option label for selected options
		 */
		update_selected_option_label: function(value) {
	        
			if (value != 'unselected') {
				
				var $selectedOption = $('.varis option[value=' + value + ']');
				var productOptionId = $selectedOption.parent().attr('id');
				var $selectedOptionLabel = $('label[for=' + productOptionId + ']');
				var $selectedOptionKey = $selectedOptionLabel.find('.selectedOptionKey');
				var $selectedOptionValue = $selectedOptionLabel.find('.selectedOptionValue'); 
				
				$selectedOptionKey.html($selectedOptionKey.text()[$selectedOptionKey.text().length - 1] == ':' ? $selectedOptionKey.text() : $selectedOptionKey.text() + ':');
				$selectedOptionValue.html(' ' + $selectedOption.text());
				if($('#isBDAppVar').val() != 'BD' && isPDPVariantGreyOutEnabled == 'true'){
				if($('span[automation-id=selectionItem_'+value+']').hasClass("select-span1-OOS")){
					if(! $selectedOptionValue.text().includes(messages.PDETAIL_IMAGE_OUT_OF_STOCK_ALT )){
						$selectedOptionValue.append(' - '+ messages.PDETAIL_IMAGE_OUT_OF_STOCK_ALT);
						}
				}else if(  $('.varis-v2 option[automation-id=varisOption_'+value+']').hasClass("out-of-stock")){
					 if(! $selectedOptionValue.text().includes(' - '+ messages.PDETAIL_IMAGE_OUT_OF_STOCK_ALT)){
				    	   const textToReplace =  $selectedOptionValue.text();
				    	   const newText = textToReplace.replace( messages.PDETAIL_IMAGE_OUT_OF_STOCK_ALT, "");
				    	   $selectedOptionValue.text(newText);
				    	   $selectedOptionValue.append(' - '+ messages.PDETAIL_IMAGE_OUT_OF_STOCK_ALT );
				       }
				}
      }
				$selectedOptionValue.show();
				if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_PDP_FEATURE_ENABLE) {
					$variant_option_input = $('input[value=' + value + ']');
					$variant_option_input.prop('checked', true);
				}
				
			} else {
				
				var $defaultOptions = $('option[value=' + value + ']');
				$defaultOptions.each(function(index, element) {
					
					if ($(element).prop('selected')) {
						
						var productOptionId = $(element).parent().attr('id');
						var $defaultOptiontLabel = $('label[for=' + productOptionId + ']');					
						var $defaultOptionKey = $defaultOptiontLabel.find('.selectedOptionKey');
						$defaultOptionKey.html($defaultOptionKey.text()[$defaultOptionKey.text().length - 1] == ':' ? $defaultOptionKey.text().substring(0, $defaultOptionKey.text().length - 1) : $defaultOptionKey.text());
						$defaultOptiontLabel.find('.selectedOptionValue').hide();
					}
				});						
			}
		},
		
		/**
		 * Function that disables/enables variant option and updates option text
		 */
		update_variant_option: function(opt, product_obj, nextVariantLength) {
			
			if(costcoStoreFeatures.WEBSITE_REDESIGN_V2_PDP_FEATURE_ENABLE && numberOfOptionsToDisplayAsTiles && nextVariantLength < numberOfOptionsToDisplayAsTiles) {
				$(opt).siblings().each(function (index, option){
					if(typeof option.innerHTML != 'undefined' && !option.innerHTML.includes(messages.OUT_OF_STOCK_TEXT)){
						$(option).removeAttr('disabled');
					}
				});
				$(opt).closest('label').removeClass('disabled');
			}
			//Update backorder / not available text for multivariant products
			if(typeof(opt.value) !== "undefined" && product_obj.options.includes(opt.value) ){
				if(product_obj.inventory === COSTCO.util.productConstants.inv_backorderd || (product_obj.zipcodeAvailabilityMessageCode === COSTCO.util.productConstants.inv_backorderd && product_obj.zipcodeAvailabilityResponseCode === COSTCO.util.productConstants.zipcodeAvailCheck_StatusFail) ) {
					
					if($(opt)[0].innerHTML.includes(messages.OUT_OF_STOCK_TEXT)){
						var sliceStr = ' - '+ messages.OUT_OF_STOCK_TEXT;
						$(opt)[0].innerHTML = $(opt)[0].innerHTML.slice(0, $(opt)[0].innerHTML.indexOf(sliceStr));
					}
					if(!$(opt)[0].innerHTML.includes(messages.BACKORDER_TEXT)){
						$(opt)[0].innerHTML += ' - '+ messages.BACKORDER_TEXT;
					}
					
				} else if(product_obj.inventory === COSTCO.util.productConstants.inv_outOfStock ||  product_obj.zipcodeAvailabilityMessageCode === COSTCO.util.productConstants.inv_outOfStock || product_obj.zipcodeAvailabilityMessageCode === COSTCO.util.productConstants.inv_invalidSku) {
					
					if($(opt)[0].innerHTML.includes(messages.BACKORDER_TEXT)){
						var sliceStr = ' - '+ messages.BACKORDER_TEXT;
						$(opt)[0].innerHTML = $(opt)[0].innerHTML.slice(0, $(opt)[0].innerHTML.indexOf(sliceStr));
					}
					if(! $(opt)[0].innerHTML.includes(messages.OUT_OF_STOCK_TEXT)){
						$(opt)[0].innerHTML += ' - '+ messages.OUT_OF_STOCK_TEXT;
					}
					if(product_obj.zipcodeAvailabilityMessageCode !== COSTCO.util.productConstants.inv_outOfStock) {
						if(costcoStoreFeatures.WEBSITE_REDESIGN_V2_PDP_FEATURE_ENABLE && numberOfOptionsToDisplayAsTiles && nextVariantLength < numberOfOptionsToDisplayAsTiles) {
							$(opt).siblings().attr('disabled', 'disabled');
							$(opt).closest('span').addClass('disabled');
						}
						$(opt).attr('disabled', 'disabled');
					}
					
				} else {
					if($(opt)[0].innerHTML.includes(messages.BACKORDER_TEXT) || $(opt)[0].innerHTML.includes(messages.OUT_OF_STOCK_TEXT)){
						if($(opt)[0].innerHTML.includes(messages.BACKORDER_TEXT)) {
							var sliceStr = ' - '+ messages.BACKORDER_TEXT;
							$(opt)[0].innerHTML = $(opt)[0].innerHTML.slice(0, $(opt)[0].innerHTML.indexOf(sliceStr));
						}
						if($(opt)[0].innerHTML.includes(messages.OUT_OF_STOCK_TEXT)) {
							var sliceStr = ' - '+ messages.OUT_OF_STOCK_TEXT;
							$(opt)[0].innerHTML = $(opt)[0].innerHTML.slice(0, $(opt)[0].innerHTML.indexOf(sliceStr));
						}
						$(opt)[0].disabled = false;
					}
				}
				if(costcoStoreFeatures.WEBSITE_REDESIGN_V2_PDP_FEATURE_ENABLE && numberOfOptionsToDisplayAsTiles && nextVariantLength < numberOfOptionsToDisplayAsTiles) {
					if(typeof(opt.value) !== "undefined" ){
						$variant_option_input = $('input[value=' + opt.value + ']');
						if(typeof ($variant_option_input.siblings('.selection-item')[0]) !== "undefined"){
							$variant_option_input.siblings('.selection-item')[0].innerHTML = $(opt)[0].innerHTML;
						}
						$variant_option_span = $variant_option_input.closest('span')
						if($variant_option_span.length > 0){
							if(product_obj.inventory === COSTCO.util.productConstants.inv_outOfStock  || product_obj.zipcodeAvailabilityMessageCode === COSTCO.util.productConstants.inv_invalidSku) {
								$variant_option_span.addClass('disabledSwatch');
							} else {
								$variant_option_span.removeClass('disabledSwatch');
							}
						}
						
					}
				}
				
			}
			
		},
		
		
		
		// A utility function to retrieve that catentry of a product by passing the product number and an array of the options selected associated with that product number.
		getCatEntryId : function(productNum,optionsSelected) {
			var catentryid;
			if (phelper.item_type == 'single') {
				return products[0][0].catentry
			} else {
				var productArray = products ? products[productNum] : [];
				var	optionsSelected = optionsSelected || phelper.get_selected_array($('.varis[data-product='+productNum+']').find('option:selected'));
				var product_selected = phelper.findItem(productArray, optionsSelected);
				return product_selected && product_selected.catentry 
					? product_selected.catentry : undefined;
			}	
		},
		getItemProgramType : function(productNum,optionsSelected){
			var programType;
			if (phelper.item_type == 'single') {
				return products[0][0].programType
			} else {
				var productArray = products ? products[productNum] : [];
				var	optionsSelected = optionsSelected || phelper.get_selected_array($('.varis[data-product='+productNum+']').find('option:selected'));
				var product_selected = phelper.findItem(productArray, optionsSelected);
				return product_selected && product_selected.programType 
					? product_selected.programType : undefined;
			}	
		},
		
		isShipToWarehouseItem : function(productNum,optionsSelected){
			var shipToWarehouse;
			if (phelper.item_type == 'single') {
				return products[0][0].shipToWarehouse;
			} else {
				var productArray = products ? products[productNum] : [];
				var	optionsSelected = optionsSelected || phelper.get_selected_array($('.varis[data-product='+productNum+']').find('option:selected'));
				var product_selected = phelper.findItem(productArray, optionsSelected);
				return (product_selected && product_selected.shipToWarehouse) ? product_selected.shipToWarehouse : false;
			}	
		},
		
		// A function that enables/disables the add-to-cart button; true = enable, false = disable.
		addToCartSwitch : function(test) {
			if(test){ 
				//add-to-car button
				$('#add-to-cart input[name=add-to-cart]').removeAttr('disabled') 
				$(".add-to-list-button").show();
				//add-to-wishlist button
				//ALM22204 Show the Add to List option once the variant is selected
				$("#add-to-wishlist").show()
				$("#addListbtn").show()
				$("#add-to-wishlist").removeClass("add-to-wishlist-desactive")
				$("#addListbtn").removeClass("add-to-wishlist-desactive")
				if($('#add-to-cart input[name=add-to-cart]').val()=='Out of Stock'){
					$('#add-to-cart input[name=add-to-cart]').attr('disabled','disabled');
				} 
			} else {
				//Add to Cart Button need not be disabled if the Contract Ajax had been invoked
				if(!isRegionalPdt){
					//add-to-car button
					$('#add-to-cart input[name=add-to-cart]').attr('disabled','disabled');	
				}
				$("#add-to-list").hide();
				//Ensure 'Add to Registry' div spans the whole row on mobile when 'Add to List' button is hidden
				$("#mr-registry-container").removeClass("col-xs-6").addClass("col-xs-12");
				
				//add-to-wishlist button
				//ALM22204 Hide the Add to List option until the variant is selected
				$("#add-to-wishlist").hide()
				$("#addListbtn").hide()
				$("#add-to-wishlist").addClass("add-to-wishlist-desactive")
				$("#addListbtn").addClass("add-to-wishlist-desactive")
			}
		},
		// Change event on region selector to associate fees with their respective region.
		regionSelector : function(){
			$('#regionDropdown').unbind('change.regionFees').on('change.regionFees', function(e) {
				CMath.pricingInfo($('.active.online-price').data('catentry'));
				CMath.showBreakdown(true);
			});
		},
		//Grocery US change - Depot Catalog Online - Retrieve the contract specific details of an item
		handleContractSpecificRules : function(){
			retryCount++;
			if((COSTCO.util.islocationControlledInventoryFlow() || (COSTCO.util.issiteControlledInventoryFlow() && phelper.item_type != 'bundle'))&& retryCount <= retryLimit){
				CMath.hideElementsBeforeAjax();	
				previousContractAjaxItem = COSTCO.Header.itemPartNumberSelcted;
				var productId=$("input[name='productBeanId']").val();
				if(productId == undefined){
					productId = product[0].catentry;
                }
				if (productId) {
					//Invoke ajax call
					//CMath.showContractSpecificData(productId);
					CMath.callAjaxInventory(productId);
				}
			}
		},
		//Grocery US change - Depot Catalog Online - Invoke ajax call
		/**
		 * Invokes the AjaxGetContractPriceCmd controller command to fetch default contract and contract based
		 * price  and handle it's response, setting the jsp view accordingly.
		 */		
		showContractSpecificData : function(data){			
			var productOnlinePrice=parseFloat(0.00).toFixed(2);			
			var catentryid = $('#catEntryId').val();			
			var pricePerUnit="";
			var dispOnZeroInv=true; 
			var isFrozenItem = $('#isFrozenItem').val();
			var isBundleItem = $('#bundleItem').val();
			var signedIn = false;
			signedIn = COSTCO.util.getMemberCookie().signedIn;
			isRegionalPdt=COSTCO.util.islocationControlledInventoryFlow();
			isRegionalPdtAvlble=false;
			blockContractAjax = false;
			$('#product-page').addClass('ajax-busy');
			//Call AJAX to get the contract prices of the given item
			COSTCO.util.ajax({
		        url: '/AjaxGetContractPrice',
		        method: 'GET',
		        dataType: 'json',
		        data: {		         
		          itemId: encodeURIComponent(data.itemId),
		          catalogId: wcs.catalogId,		          
		          productId:data.productId[0],
		          isFrozenItem:isFrozenItem,
		          isRegionalPdt:isRegionalPdt,
		          isBundleItem:isBundleItem
		          
		        },
		        done: function(data, textStatus, jqXHR, options) {
		        	$('#product-page').removeClass('ajax-busy');
		        	CMath.showBreakdown(false); 
		        	if(data.errorMessageKey) {
		        		//setUp2DayErrorPage with zip code overlay
		        		if(data.errorMessageKey == 'ERR_2DAY_PRICE_INVALID'){
		        			CMath.handleContractPriceAjaxFailure(data);
		        		}else{
		        			CMath.setUp2DayErrorPage();	
			        		if(!signedIn){
			        			$('.view-zip-signin').removeClass('hide');
			        		}
			        		$('.grocery-zip-form').removeClass('hide');
			        		$('.your-price .value').text('- -.- -');
			        		$('.unitcurrency').text('$-.- -'); 
			        		$('.math-table').show();
			        		$('#price-per-unit-container').show();
			        		//Paint the error message on the zip code overlay
			        		if(data.errorMessageKey!='ERR_ZIP_NOTVALID'){
			        			$('.alert-notification').empty();
				        		$('.critical-notification').empty();
			        			let error = COSTCO.util.get_decoded_html(data.errorMessage);
			        			
			        			if(data.errorMessageKey != 'ERR_2DAY_NOT_AVAILABLE' && data.errorMessageKey != 'ERR_2DAY_ITEM_UNAVAILABLE'
			        				&& data.errorMessageKey != 'ERR_LOCATIONCONTROLLED_ITEM_UNAVAILABLE'){
			        				error = error.replace(/[0-9]*\./,$.cookie('invCheckPostalCode')+'.');
			        			}
			        			CMath.addBorderToShipItMolecule('default'); 
			        			$('.alert-notification').append(error);
			        			$('.alert-notification').removeClass('hide');
			        			$('.critical-notification').addClass('hide');
			        		}
		        		}
	        			$('.online-price[data-catentry='+catentryid+']').data('inv', COSTCO.util.productConstants.zipcodeAvailCheck_StatusFail);
	        			$('.edd-container').hide();
	        			$('#edd-message-block').hide();
	        			$('#backorder-message').hide();

						COSTCO.Product.toggleDeliveryMoleculeOnComingSoon();
		        	}else{
		        		productOnlinePrice = data.finalOnlinePrice;	
		        		pricePerUnit=data.pricePerUnit;
		        		discount=data.discount;
		        		catentryid=data.itemId;
		        		//if there exists value for price
		        		if( typeof productOnlinePrice !== 'undefined' && (!isNaN(productOnlinePrice))){
		        			//if there exists value for discount, show discount node
		        			if(typeof discount !== 'undefined' && !isNaN(discount) && discount != 0.0) {
		        				$('.disc[data-catentry='+catentryid+']').toggleClass('hide active');
		        				$('.disc[data-catentry='+catentryid+'] .disc-value').text(phelper.formatMoney(phelper.processPrice(discount)));
		        				$('.disc[data-catentry='+catentryid+']').data('disc',COSTCO.util.encode(discount+''));
		        				CMath.showBreakdown(true);
		        			} else {
		        				//remove the discount node if there is no discount
		        				if($('.disc').length > 0) {
		        					$('.disc[data-catentry='+catentryid+']').toggleClass('active hide');
		        				}		        				
		        			}	
		        			//Paint the contract price on PDP and encode the final item price to PDP page
		        			$('.online-price[data-catentry='+catentryid+'] .op-value').text(phelper.formatMoney(phelper.processPrice(productOnlinePrice)));		        			
		        			$('.online-price[data-catentry='+catentryid+']').data('opvalue', COSTCO.util.encode(productOnlinePrice+''));  
		        			if(!$('.online-price').length && !$('.your-price').length ){
		        				if($('.marketing-container .merchandisingText').text()==''){
		        					$('.marketing-container .merchandisingText').text("Starting at $"+phelper.formatMoney(phelper.processPrice(productOnlinePrice)));
		        				}
		        			}
		        			if(pricePerUnit.length > 0){
		        				//populate the price per unit based on contract price
								$('.unitcurrency').text('$' + phelper.formatMoney(phelper.processPrice(pricePerUnit)));
		        			}
		        					        			
		        			if($('.unitcurrency').text() == null || $('.unitcurrency').text() == '$-.- -' || $('.unitcurrency').text().trim() == '' || COSTCO.util.getLocale() == 'fr-CA'){
								$('#price-per-unit-container').addClass('hide');
							}
							else{
								$('#price-per-unit-container').show();
								$('#price-per-unit-container').removeClass('hide');
							}
			        		//Handle other render events - 
		        			//Rules to hide/show UI elements , based on bussines requirement -
		        			//This will only be executed after Successfull price update.
		        			
		        				CMath.pricingInfo($('.online-price[data-catentry='+catentryid+']').data('catentry'),productOnlinePrice);
		        			} 			        			        		
		        	}
		        },fail: function(data) {
		        	CMath.handleContractPriceAjaxFailure(data);		        	
		        }		        
		      });
		},
		callAjaxInventory : function(productId){
			
			var catentryid = $('#catEntryId').val();
			if(catentryid==undefined){
				catentryid = products[0][0].catentry;
			}
			var dispOnZeroInv=true; 
			var isFrozenItem = $('#isFrozenItem').val();
			var isBundleItem = $('#bundleItem').val();
			var whParam = COSTCO.LWSearch.getRegionalLocations();  
			var warehouse = COSTCO.LWSearch.fetchWarehouseCookieVal('nearestWarehouse');
			var signedIn = false;
			 backordered = false;
			 COSTCO.CMath.isBackOrderFlag=false;
			 initalizeAjaxCall=true;
			var backorderMessage = '';
			signedIn = COSTCO.util.getMemberCookie().signedIn;
			isRegionalPdt=COSTCO.util.islocationControlledInventoryFlow();
			isRegionalPdtAvlble=false;
			COSTCO.CMath.invAvailableAjax =false;
			COSTCO.CMath.isWarehouseEnabled = false;
			blockContractAjax = false;
			$('#product-page').addClass('ajax-busy');
        	COSTCO.util.ajax({
		        url: '/AjaxGetInventoryDetail',
		        method: 'GET',
		        dataType: 'json',
		        data: {		         
		          itemId: encodeURIComponent(catentryid),
		          catalogId: wcs.catalogId,		          
		          productId:productId,
		          WH:whParam,
		          warehouse:warehouse,
		          isFrozenItem:isFrozenItem,
		          isRegionalPdt:isRegionalPdt,
		          isBundleItem:isBundleItem
		        },
		        done: function(data, textStatus, jqXHR, options) {
		        	$('#product-page').removeClass('ajax-busy');
		        	var scheduledDeliverable = $('#scheduledDeliverable').val()=="true"?true:false;
		        	//Display out of stock overlay over product image
		        	if(data.errorMessageKey) {
	                        CMath.setUp2DayErrorPage();    
	                        if(!signedIn){
	                            $('.view-zip-signin').removeClass('hide');
	                        }
	                        $('.grocery-zip-form').removeClass('hide');
	                       //Read variable from jsp to see whether price call happened already
	                  	  	var isPriceCallInvokedForPickup =  $('#isPriceCallInvokedForPickup').val();
	                  	  	if(isPriceCallInvokedForPickup == 'false'){
	                  	  		$('.your-price .value').text('- -.- -');
	                  	  	}
	                        $('.unitcurrency').text('$-.- -'); 
	                        $('.math-table').show();
	                        $('#price-per-unit-container').show();
	                        if( $('#price-per-unit-container').hasClass('hide') && isPriceCallInvokedForPickup == 'false'){
	                        	$('#price-per-unit-container').removeClass('hide');
	                        }
	                        //Paint the error message on the zip code overlay
	                        if(data.errorMessageKey!='ERR_ZIP_NOTVALID'){
	                            $('.alert-notification').empty();
	                            $('.critical-notification').empty();
	                            let error = COSTCO.util.get_decoded_html(data.errorMessage);
	                            
	                            if(data.errorMessageKey != 'ERR_2DAY_NOT_AVAILABLE' && data.errorMessageKey != 'ERR_2DAY_ITEM_UNAVAILABLE'
	                                && data.errorMessageKey != 'ERR_LOCATIONCONTROLLED_ITEM_UNAVAILABLE'){
	                                error = error.replace(/[0-9]*\./,$.cookie('invCheckPostalCode')+'.');
	                            }
	                            CMath.addBorderToShipItMolecule('default'); 
	                            $('.alert-notification').append(error);
	                            $('.alert-notification').removeClass('hide');
	                            $('.critical-notification').addClass('hide');
	                        }
	                        
		        		$('.online-price[data-catentry='+catentryid+']').data('inv', COSTCO.util.productConstants.zipcodeAvailCheck_StatusFail);
	        			$('.edd-container').hide();
	        			$('#edd-message-block').hide();
	        			$('#backorder-message').hide();
	        			if( isPDPVariantGreyOutEnabled == 'true' && (COSTCO.Product.item_type === 'multi_variant' || COSTCO.Product.item_type === 'single_variant')){
	        				let optionsSelected = COSTCO.Product.get_selected_array($('.varis[data-product=0]').find('option:selected'));
	 		      			var len = optionsSelected.length;
	        				 var itemPartNumber = COSTCO.Product.getPartnumber();
	        				 var lowerSwatch=$('#swatches-productOption0'+parseInt(len-1)+'').length > 0 ;
	 		      			var lowerDropDown=$('.varis-v2[automation-id=varisSwatch_0'+parseInt(len-1)+']').length>0 ;
	 		      		 $('#swatches-productOption0'+parseInt(len-1)+' .selection-box-v2').find('span.selection-item').each(function(){
		        	            $(this).removeClass("select-span1-OOS");
		        	        });
	        				 var status ='0';
		        			COSTCO.CMath.updateAjaxStockStatus(status,itemPartNumber,lowerSwatch,lowerDropDown);
		        			COSTCO.CMath.isErrorlocationControlleditem=true;
						//Following code for invoke batch API if we are switching upper level swatch/dropdown 
						if($('div.buyinstoreonly.MuiBox-root').length >0){
		       				  COSTCO.CMath.isWarehouseEnabled=true;
		       				}else{
		       					COSTCO.CMath.isWarehouseEnabled=false;
		       				}
		        			COSTCO.CMath.invokeBatchCallForUpperLevel(itemPartNumber);
	        			}
						//Check for coming soon flag
						COSTCO.Product.toggleDeliveryMoleculeOnComingSoon();
		        	}else{
		        		let optionsSelected = COSTCO.Product.get_selected_array($('.varis[data-product=0]').find('option:selected'));
		      			var len = optionsSelected.length;
		      			var lowerSwatch=$('#swatches-productOption0'+parseInt(len-1)+'').length > 0 ;
		      			var lowerDropDown=$('.varis-v2[automation-id=varisSwatch_0'+parseInt(len-1)+']').length>0 ;
		      			var itemPartNumber = COSTCO.Product.getPartnumber();
		      			COSTCO.CMath.isErrorlocationControlleditem=false;
		        	isRegionalPdtAvlble=data.invAvailable;
		        	 COSTCO.CMath.invAvailableAjax = data.invAvailable;
		        	 COSTCO.CMath.isWarehouseEnabled = data.isWarehouseEnabled;
		        	dispOnZeroInv=data.dispOnZeroInvtry;
		        	backordered = data.isBackOrdered;
		        	COSTCO.CMath.isBackOrderFlag = data.isBackOrdered;
	        		backorderMessage = data.backOrderMessage;
	        		COSTCO.CMath.invokeAjaxCall =true;
	        		COSTCO.CMath.isWioEnabled = data.isWioEnabled;
	        		COSTCO.CMath.isBopiwEnabled = data.isBopiwEnabled;
	        		

					//If the product coming soon and feature flags are false, do this
					if(!(Array.isArray(product) && product.length && product[0].isComingSoon && comingSoonFeatureFlag)){
						if( isPDPVariantGreyOutEnabled == 'true' && !scheduledDeliverable){
			        		 $('#swatches-productOption0'+parseInt(len-1)+' .selection-box-v2').find('span.selection-item').each(function(){
			        	            $(this).removeClass("select-span1-OOS");
			        	        });
			        		 //Following code for invoke batch API if we are switching upper level swatch/dropdown 
			        	COSTCO.CMath.invokeBatchCallForUpperLevel(itemPartNumber);
		        		}
						if(isPDPVariantGreyOutEnabled == 'false'){
						if(!isRegionalPdtAvlble && dispOnZeroInv && !backordered ){  
		        			var oosImgTag = COSTCO.util.tmpl('tmpl_oos_overlay_img');
			        		$('#productImageOverlay').prepend(oosImgTag);
			        		$('.primary-clause').hide();
						}else {
		        			if (!$('#vendorName').val()) {
		        				$('.primary-clause').show();
		        			}
						}
						}
	        		if(!isRegionalPdtAvlble &&  !backordered && isPDPVariantGreyOutEnabled == 'true'  && !scheduledDeliverable){
	        			var status ='0';
	        			COSTCO.CMath.updateAjaxStockStatus(status,itemPartNumber,lowerSwatch,lowerDropDown);
	        			
	        			
		        		//$('.primary-clause').show();
	        		}else {
	        			if( isPDPVariantGreyOutEnabled == 'true'  && !scheduledDeliverable){
	        				var status ='1';
	        				COSTCO.CMath.updateAjaxStockStatus(status,itemPartNumber,lowerSwatch,lowerDropDown);
	        			
	        			//Following code for remove css of previous selected swatches
	        			 if(lowerSwatch){// pills
	        				 if(COSTCO.Product.item_type === 'multi_variant'  ){
		        				 var len = optionsSelected.length;
		        				 variable= $('input[value=' +optionsSelected[len-1]+ ']').next().attr("automation-id");
		        				 
		        			 }else if(COSTCO.Product.item_type === 'single_variant'){
		        				 $('.selection-item').removeClass("select-span1-OOS");
		        				 variable= $('input[value=' +optionsSelected[0]+ ']').next().attr("automation-id");  
		        			 }
	        			 $('span[automation-id='+variable+']').removeClass("select-span1-OOS");
	        			 $('span[automation-id='+variable+']').removeClass("span1-outofstock");	
	        			 $('span[automation-id='+variable+']').children("p").remove();// for removing P tag
	        			 }else if(lowerDropDown){// lower level drop-down
	        				 $('.varis-v2 option[automation-id=varisOption_'+optionsSelected[len-1]+']').removeClass("out-of-stock");
	        				 $('.varis-v2 option[automation-id=varisOption_'+optionsSelected[len-1]+']').children("span").remove();
	        				 COSTCO.CMath.update_selected_option_label(optionsSelected[len-1]);
	        			 }
	        			 if($('#swatches-productOption0'+parseInt(optionsSelected.length-2)+'').length > 0 ){
	        					COSTCO.Product.strikeUpperLevelVariant(optionsSelected);
	        				}else if($('.varis-v2[automation-id=varisSwatch_0'+parseInt(optionsSelected.length-2)+']').length>0 ){
	        					COSTCO.Product.grayOutUpperLevelDropDown(optionsSelected);
	        				}
	        			
	        		
	        			}
	        		}
	        		var isEDDItem = $('#liveEDD').length > 0 && $('#liveEDD').val() === 'true';
	        		//For LocationControlledInventory Items 
	        		if(backordered && backorderMessage !== ''){
	        			$('#backorder-message').text(backorderMessage);
	        			$('#backorder-message').append('<span id="backordered"></span>');
						$('#backorder-message').show();
						$('.edd-container').hide();
						$('#edd-message-block').hide();
						$('.online-price[data-catentry='+catentryid+']').data('inv', COSTCO.util.productConstants.inv_backorderd);
						if(isRegionalPdt){
						 $('.primary-clause').hide(); //Added this for Depozipin hide this message in delivery molecule
						}
	        		}else{
	        			$('#backorder-message').hide();
						$('.edd-container').show();
						$('.online-price[data-catentry='+catentryid+']').data('inv', 'IN_STOCK');
						if (isRegionalPdtAvlble && !isEDDItem) {
							$('.primary-clause').show();
						}
	        		}
	        		//if inventory not available and display on zero inventory flag off show product not found view
	        		
	        		if(!isRegionalPdtAvlble && !dispOnZeroInv && phelper.item_type == 'single' && !isEDDItem){
	        			COSTCO.Product.invokeInventoryBatchAPIcallforSingleitem(itemPartNumber);
	        			
	        			
	        		}
              //depozip in small pack edd msg hide
	        		if(!isRegionalPdtAvlble && isRegionalPdt && COSTCO.Product.isLocCtrlSmallPck){
	        			 $('.edd-container').hide();
	                        $('#edd-message-block').hide(); 
	                        $('.primary-clause').hide();
	        		}
	        		//Added this for Depozipin hide this message in delivery molecule
	        		if(!isRegionalPdtAvlble && isRegionalPdt && !isEDDItem){
	        			 $('.primary-clause').hide();
	        		}
              //depozip in small pack edd msg hide
	        		if(!isRegionalPdtAvlble && isRegionalPdt && COSTCO.Product.isLocCtrlSmallPck){
	        			 $('.edd-container').hide();
	                        $('#edd-message-block').hide(); 
	                        $('.primary-clause').hide();
	        		}
	        		//Added this for Depozipin hide this message in delivery molecule
	        		if(!isRegionalPdtAvlble && isRegionalPdt && !isEDDItem){
	        			 $('.primary-clause').hide();
	        		}
              //depozip in small pack edd msg hide
	        		if(!isRegionalPdtAvlble && isRegionalPdt && COSTCO.Product.isLocCtrlSmallPck){
	        			 $('.edd-container').hide();
	                        $('#edd-message-block').hide(); 
	                        $('.primary-clause').hide();
	        		}
	        		//Added this for Depozipin hide this message in delivery molecule
	        		if(!isRegionalPdtAvlble && isRegionalPdt && !isEDDItem){
	        			 $('.primary-clause').hide();
	        		}
	        		if(!isRegionalPdtAvlble && !isRegionalPdt){
                        $('.edd-container').hide();
                        $('#edd-message-block').hide(); 
                        $('.primary-clause').hide();
                        COSTCO.CMath.siteControllOOS=true;
                    }else{
                        if(isEDDItem && !backordered){
                            $('.edd-container').show();
                            $('#edd-message-block').show();
                            if (!$('#vendorName').val()) {
    	        				$('.primary-clause').show();
    	        			}
                        }
                    }
	        		if( isPDPVariantGreyOutEnabled == 'true' && !scheduledDeliverable){
	        		if(lowerSwatch){
	        			 var lowerLevelCount = $('#swatchesID-productOption0'+parseInt(optionsSelected.length-1)+'').find('.selection-box-v2:visible').length;
	                     var lowerLevelOOSCount = $('#swatchesID-productOption0'+parseInt(optionsSelected.length-1)+'').find('.span1-outofstock').length;
	                      if ( lowerLevelCount === lowerLevelOOSCount) {
	                     	 COSTCO.Product.strikeUpperLevelVariant(optionsSelected);
	                     	
	                      } else{
	                    	  var $selectedUpperLabel = $('label[for=productOption0'+parseInt(optionsSelected.length-2)+']');
	                          var $newValueWithoutOOS = $selectedUpperLabel.find('.selectedOptionValue').text().split(' - '+ messages.PDETAIL_IMAGE_OUT_OF_STOCK_ALT)[0];
	                          $selectedUpperLabel.find('.selectedOptionValue').text($newValueWithoutOOS); 

	                          var $selectedOOSOption = $('input[value=' + optionsSelected[optionsSelected.length-2] + ']').next().attr("automation-id");
	                          $('span[automation-id=' + $selectedOOSOption + ']').removeClass("span1-outofstock");
	                          $('span[automation-id=' + $selectedOOSOption + ']').removeClass("select-span1-OOS");
	                          $('span[automation-id=' + $selectedOOSOption + ']').children("p").remove();
	                          if(optionsSelected.length == 3){
	                        	  var $selectedUpperLabel = $('label[for=productOption0'+parseInt(optionsSelected.length-3)+']');
		                          var $newValueWithoutOOS = $selectedUpperLabel.find('.selectedOptionValue').text().split(' - '+ messages.PDETAIL_IMAGE_OUT_OF_STOCK_ALT)[0];
		                          $selectedUpperLabel.find('.selectedOptionValue').text($newValueWithoutOOS); 

		                          var $selectedOOSOption = $('input[value=' + optionsSelected[optionsSelected.length-3] + ']').next().attr("automation-id");
		                          $('span[automation-id=' + $selectedOOSOption + ']').removeClass("span1-outofstock");
		                          $('span[automation-id=' + $selectedOOSOption + ']').removeClass("select-span1-OOS");
		                          $('span[automation-id=' + $selectedOOSOption + ']').children("p").remove();
	                          }
	                      }
	        		}else if(lowerDropDown){
	        			var lowerLevelDropDownCount = $('.varis-v2[automation-id=varisSwatch_0'+parseInt(optionsSelected.length-1)+']').find('option.opt:not(:disabled)').length;
	        		     var lowerLevelDropDownOOSCount = $('.varis-v2[automation-id=varisSwatch_0'+parseInt(optionsSelected.length-1)+']').find('option.out-of-stock:not(:disabled)').length;
	        		     if ( lowerLevelDropDownCount === lowerLevelDropDownOOSCount) {

	        		   	  if(! $('.varis-v2 option[automation-id=varisOption_'+optionsSelected[optionsSelected.length-2]+']').hasClass('out-of-stock')) {
	        		   		  $('.varis-v2 option[automation-id=varisOption_'+optionsSelected[optionsSelected.length-2]+']').append('<span class="out-of-stock-text"></span>');
	        		   		 $('.varis-v2 option[automation-id=varisOption_'+optionsSelected[optionsSelected.length-2]+']').find('.out-of-stock-text').text('  '+messages.PDETAIL_IMAGE_OUT_OF_STOCK_ALT );
	        		  	      $('.varis-v2 option[automation-id=varisOption_'+optionsSelected[optionsSelected.length-2]+']').addClass("out-of-stock");
	        		  	  	var $selectedOptionLabel = $('label[for=productOption0'+parseInt(len-2)+']');
	        		  		var $selectedOptionValue = $selectedOptionLabel.find('.selectedOptionValue'); 
	        		  		if(! $selectedOptionValue.text().includes(' - '+ messages.PDETAIL_IMAGE_OUT_OF_STOCK_ALT )){
	        		  		//$selectedOptionValue.prepend('Out of Stock - ' );
	        		  			const textToReplace =  $selectedOptionValue.text();
	        		  			const newText = textToReplace.replace(messages.PDETAIL_IMAGE_OUT_OF_STOCK_ALT, "");
	        		  			$selectedOptionValue.text(newText);
	        		  			$selectedOptionValue.append(' - '+ messages.PDETAIL_IMAGE_OUT_OF_STOCK_ALT );
	        		  		}
	        		  		$selectedOptionValue.show();
	        		   	  	}
	        		        
	        		     }else{
	        		    	    var $dropDownOptionLabel = $('label[for=productOption0' + parseInt(optionsSelected.length-2) + ']');
	        		    	    var $dropDownValueWithoutOOS = $dropDownOptionLabel.find('.selectedOptionValue').text().split(' - '+ messages.PDETAIL_IMAGE_OUT_OF_STOCK_ALT)[0];
	        		    	    $dropDownOptionLabel.find('.selectedOptionValue').text($dropDownValueWithoutOOS);
	        		    	    var $dropDownOOSOption = $('.varis-v2 option[value=' + optionsSelected[optionsSelected.length-2] + ']').attr("automation-id");
	        		    	    $('.varis-v2 option[automation-id=' + $dropDownOOSOption + ']').removeClass("out-of-stock");
	        		    	    $('.varis-v2 option[automation-id=' + $dropDownOOSOption + ']').children(".out-of-stock-text").remove();
	        		    	    if(optionsSelected.length == 3){
	        		    	    	 var $dropDownOptionLabel = $('label[for=productOption0' + parseInt(optionsSelected.length-3) + ']');
	 	        		    	    var $dropDownValueWithoutOOS = $dropDownOptionLabel.find('.selectedOptionValue').text().split(' - '+ messages.PDETAIL_IMAGE_OUT_OF_STOCK_ALT)[0];
	 	        		    	    $dropDownOptionLabel.find('.selectedOptionValue').text($dropDownValueWithoutOOS);
	 	        		    	    var $dropDownOOSOption = $('.varis-v2 option[value=' + optionsSelected[optionsSelected.length-3] + ']').attr("automation-id");
	 	        		    	    $('.varis-v2 option[automation-id=' + $dropDownOOSOption + ']').removeClass("out-of-stock");
	 	        		    	    $('.varis-v2 option[automation-id=' + $dropDownOOSOption + ']').children(".out-of-stock-text").remove();
		                          }
	        		    	 
	        		     }
	        			
	        		}
	        		//For 3 level varaints in order to retain  top level strike when swaping between other top levels
	        		COSTCO.CMath.strikealllevelvariants();
				}
			}
					CMath.mathTableDisplayRules();
	        		CMath.showContractSpecificData(data);
		        	}
	        	 },fail: function(data) {
		        	//CMath.handleContractPriceAjaxFailure(data);
		        	console.log('ajax fail - will retry - count=' + retryCount);
					CMath.handleContractSpecificRules();
		        }
        	});
		},
		updateAjaxStockStatus : function(status,itemPartNumber,lowerSwatch,lowerDropDown){
			 if(COSTCO.Product.item_type === 'multi_variant' || COSTCO.Product.item_type === 'single_variant'){
				 let optionsSelected = COSTCO.Product.get_selected_array($('.varis[data-product=0]').find('option:selected'));
	      			var len = optionsSelected.length;
			 var uptitemarrayStatus = {};
			  var uptvariantitemArray ={};
			  if(COSTCO.CMath.variantJSON.length >0){
			for(var i in COSTCO.CMath.variantJSON){
				var val = COSTCO.CMath.variantJSON[i];
			    for(var j in val){
			        var sub_key = j;
			        var sub_val = val[j];
			       if(sub_key == itemPartNumber){
	        			  uptitemarrayStatus ["OL"] = status;
	        			  uptitemarrayStatus ["WH"] =sub_val.WH;
			        	 uptvariantitemArray[itemPartNumber] =uptitemarrayStatus;
			        	 COSTCO.CMath.variantJSON[i] =uptvariantitemArray;
			        	 localStorage.setItem('variantStatus',JSON.stringify( COSTCO.CMath.variantJSON));
			       }
			    }
			}
			for(var i in COSTCO.CMath.variantJSON){
				var val = COSTCO.CMath.variantJSON[i];
			    for(var j in val){
			        var sub_key = j;
			        var sub_val = val[j];
			       if(sub_key == itemPartNumber){
			        	 if(status == '0' && sub_val.WH == '0'){
			        		 if(COSTCO.Product.item_type === 'multi_variant'  ){
		        				 if(lowerSwatch){
		        					 COSTCO.CMath.ajaxStrikeSwatches();
		        				 } else if(lowerDropDown){
		        					 COSTCO.CMath.ajaxGrayOutDropDown(); 
		        				 }
		        			 }else if(COSTCO.Product.item_type === 'single_variant'){
		        				 if($('#swatches-productOption00').length > 0 ){
		        					 COSTCO.CMath.ajaxStrikeSwatches();
		        				 } else if($('.varis-v2[data-product=0]').length>0 ){
		        					 COSTCO.CMath.ajaxGrayOutDropDown(); 
		        				 }
		        			}
			        	 }else{
	    			        	//Following code for remove css of previous selected swatches
		 	        			
	 	        			 if(lowerSwatch){// pills
	 	        				 if(COSTCO.Product.item_type === 'multi_variant'  ){
	 		        				
	 		        				 variable= $('input[value=' +optionsSelected[len-1]+ ']').next().attr("automation-id");
	 		        				 
	 		        			 }else if(COSTCO.Product.item_type === 'single_variant'){
	 		        				 $('.selection-item').removeClass("select-span1-OOS");
	 		        				 variable= $('input[value=' +optionsSelected[0]+ ']').next().attr("automation-id");  
	 		        			 }
	 	        			 $('span[automation-id='+variable+']').removeClass("select-span1-OOS");
	 	        			 $('span[automation-id='+variable+']').removeClass("span1-outofstock");	
	 	        			 $('span[automation-id='+variable+']').children("p").remove();// for removing P tag
	 	        			 }else if(lowerDropDown){// lower level drop-down
	 	        				 $('.varis-v2 option[automation-id=varisOption_'+optionsSelected[len-1]+']').removeClass("out-of-stock");
	 	        				 $('.varis-v2 option[automation-id=varisOption_'+optionsSelected[len-1]+']').children("span").remove();
	 	        				
	 	        			 }
	 	        			 COSTCO.CMath.update_selected_option_label(optionsSelected[len-1]);
	    			        	 }
	 	        			 if($('#swatches-productOption0'+parseInt(optionsSelected.length-2)+'').length > 0 ){
	 	        					COSTCO.Product.strikeUpperLevelVariant(optionsSelected);
	 	        				}else if($('.varis-v2[automation-id=varisSwatch_0'+parseInt(optionsSelected.length-2)+']').length>0 ){
	 	        					COSTCO.Product.grayOutUpperLevelDropDown(optionsSelected);
	 	        				}
			        }
			     }
			}
			  }
			 }
		},
		invokeBatchCallForUpperLevel : function(itemPartNumber){
			let optionsSelected = COSTCO.Product.get_selected_array($('.varis[data-product=0]').find('option:selected'));
			var len = optionsSelected.length;
			if(COSTCO.CMath.pdpPageloadComplete){
				var invokeBatchAPICall =true;
				for(var i in COSTCO.CMath.variantJSON){
    			
    				var val = COSTCO.CMath.variantJSON[i];
    			 	  for(var j in val){
    			        var sub_key = j;
    			        if(sub_key == itemPartNumber){
    			        	 invokeBatchAPICall =false;
    			         }
    			    }
    			}
			  			
				for (var i=0; i < optionsSelected.length;i++){
					if(optionsSelected[i]!= COSTCO.CMath.selectedswatches[i] && i != optionsSelected.length-1){
						COSTCO.CMath.invokebatchCall = true;
						break
					}
				}
				var scheduledDeliverable = $('#scheduledDeliverable').val()=="true"?true:false;
				if(COSTCO.CMath.invokebatchCall  && !scheduledDeliverable &&
						(COSTCO.Product.item_type === 'multi_variant' || COSTCO.Product.item_type === 'single_variant') ){
					$('#PDPSwatchSkeletone-productOption0'+parseInt(optionsSelected.length-1)+'').show();
					$('#swatchesID-productOption0'+parseInt(optionsSelected.length-1)+'').hide();
					$('[name=productOption0'+parseInt(optionsSelected.length-1)+']').hide();
					$('.dropdown-skeleton-productOption0'+parseInt(optionsSelected.length-1)+'').show();
					 $('#swatches-productOption0'+parseInt(len-2)+' .selection-box-v2').find('span.selection-item').each(function(){
	        	            $(this).removeClass("select-span1-OOS");
	        	        });
					 $('#swatches-productOption00 .selection-box-v2').find('span.selection-item').each(function(){
	        	            $(this).removeClass("select-span1-OOS");
	        	      });
					$('.varis-v2[automation-id=varisSwatch_0'+parseInt(len-1)+']').find('option.opt:not(:disabled)').each(function(){
							 $(this).removeClass("out-of-stock");
							 $(this).children("span").remove();
							 CMath.update_selected_option_label(optionsSelected[len-1]);
						 });
						 $('#swatches-productOption0'+parseInt(len-1)+' .selection-box-v2').find('span.selection-item').each(function(){
							 $(this).removeClass("span1-outofstock");
                             $(this).children("p").remove();// for removing P
															// tag;
		        	           CMath.update_selected_option_label(optionsSelected[len-1]);
		        	        });
		        		
					COSTCO.Product.findOOSitem(invokeBatchAPICall);
				}
			}
		},
		ajaxStrikeSwatches : function(){
		 let optionsSelected = COSTCO.Product.get_selected_array($('.varis[data-product=0]').find('option:selected'));
		 var len = optionsSelected.length;
		
		  // $('.selection-item').removeClass("select-span1-OOS");
		
			    variable= $('input[value=' +optionsSelected[len-1]+ ']').next().attr("automation-id");
			    if($("input[automation-id='variationOptions_"+optionsSelected[len-1]+"']:checked").length ){
			    //if($('span[automation-id='+variable+']').attr('aria-checked') === 'true'){
					$('span[automation-id='+variable+']').addClass("select-span1-OOS");
					//folowing  code for appending OOS label in lower level
					COSTCO.Product.appendLabelSwatches(len-1);
				}else{
					
					$('span[automation-id='+variable+']').removeClass("select-span1-OOS");
				}
			    if(!$('span[automation-id='+variable+']').hasClass('span1-outofstock')) {
			    	$('span[automation-id='+variable+']').addClass("span1-outofstock");
			    } else{
			    	if(! $('span[automation-id='+variable+']').children('p').length) {
		                $('span[automation-id='+variable+']').append('<p class="p-outofstock"><span class="sr-only"></span></p>');
		                $('span[automation-id='+variable+']').find('.p-outofstock span.sr-only').text(' '+messages.PDETAIL_IMAGE_OUT_OF_STOCK_ALT);
		            }  
			    }
			
		},
		ajaxGrayOutDropDown : function(){
			 let optionsSelected = COSTCO.Product.get_selected_array($('.varis[data-product=0]').find('option:selected'));
			 var len = optionsSelected.length;
				
			 if(! $('.varis-v2 option[automation-id=varisOption_'+optionsSelected[len-1]+']').hasClass('out-of-stock')) {
			 $('.varis-v2 option[automation-id=varisOption_'+optionsSelected[len-1]+']').append('<span class="out-of-stock-text"></span>');
			 $('.varis-v2 option[automation-id=varisOption_'+optionsSelected[len-1]+']').find('.out-of-stock-text').text('  '+messages.PDETAIL_IMAGE_OUT_OF_STOCK_ALT );
		       $('.varis-v2 option[automation-id=varisOption_'+optionsSelected[len-1]+']').addClass("out-of-stock");
		       var $selectedOptionLabel = $('label[for=productOption0'+parseInt(len-1)+']');
				var $selectedOptionValue = $selectedOptionLabel.find('.selectedOptionValue');
		       if(! $selectedOptionValue.text().includes(' - '+ messages.PDETAIL_IMAGE_OUT_OF_STOCK_ALT )){
		    	   const textToReplace =  $selectedOptionValue.text();
		    	   const newText = textToReplace.replace(messages.PDETAIL_IMAGE_OUT_OF_STOCK_ALT, "");
		    	   $selectedOptionValue.text(newText);
		    	   $selectedOptionValue.append(' - '+ messages.PDETAIL_IMAGE_OUT_OF_STOCK_ALT );
		       }
				$selectedOptionValue.show();
			 }
			
		},
		callAjaxBundleInventory : function(productId,itemId,count,size){
			
			var catentryid =itemId ;
			var dispOnZeroInv=true; 
			var isFrozenItem = $('#isFrozenItem').val();
			var isBundleItem = $('#bundleItem').val();
			var whParam = COSTCO.LWSearch.getRegionalLocations(); 
			var warehouse = COSTCO.LWSearch.fetchWarehouseCookieVal('nearestWarehouse');
			var signedIn = false;
			 backordered = false;
			 initalizeAjaxCall=true;
			var backorderMessage = '';
			signedIn = COSTCO.util.getMemberCookie().signedIn;
			isRegionalPdt=COSTCO.util.islocationControlledInventoryFlow();
			isRegionalPdtAvlble=false;
			blockContractAjax = false;
			$('#product-page').addClass('ajax-busy');
        	COSTCO.util.ajax({
		        url: '/AjaxGetInventoryDetail',
		        method: 'GET',
		        async: false,
		        dataType: 'json',
		        data: {		         
		          itemId: encodeURIComponent(itemId),
		          catalogId: wcs.catalogId,		          
		          productId:productId,
		          WH:whParam,
		          warehouse:warehouse,
		          isFrozenItem:isFrozenItem,
		          isRegionalPdt:isRegionalPdt,
		          isBundleItem:isBundleItem
		        },
		        done: function(data, textStatus, jqXHR, options) {
		        	$('#product-page').removeClass('ajax-busy');
		        	if(data.errorMessageKey) {
		        		$('.online-price[data-catentry='+catentryid+']').data('inv', COSTCO.util.productConstants.zipcodeAvailCheck_StatusFail);
	        			$('.edd-container').hide();
	        			$('#edd-message-block').hide();
	        			$('#backorder-message').hide();
						
		        	}else{
		        	isRegionalPdtAvlble=data.invAvailable;
		        	dispOnZeroInv=data.dispOnZeroInvtry;
		        	backordered = data.isBackOrdered;
	        		backorderMessage = data.backOrderMessage;
	        		if(isPDPVariantGreyOutEnabled == 'false'){
						if(!isRegionalPdtAvlble && dispOnZeroInv && !backordered ){  
		        			var oosImgTag = COSTCO.util.tmpl('tmpl_oos_overlay_img');
			        		$('#productImageOverlay').prepend(oosImgTag);
			        		$('.primary-clause').hide();
						}else {
		        			if (!$('#vendorName').val()) {
		        				$('.primary-clause').show();
		        			}
						}
						}else{
	        		
	        			if (!$('#vendorName').val()) {
	        				$('.primary-clause').show();
	        			}
						}
	        		var isEDDItem = $('#liveEDD').length > 0 && $('#liveEDD').val() === 'true';
	        		//For LocationControlledInventory Items 
	        		if(backordered && backorderMessage !== ''){
	        			$('#backorder-message').text(backorderMessage);
	        			$('#backorder-message').append('<span id="backordered"></span>');
						$('#backorder-message').show();
						$('.edd-container').hide();
						$('#edd-message-block').hide();
						$('.online-price[data-catentry='+catentryid+']').data('inv', COSTCO.util.productConstants.inv_backorderd);
					}else{
						$('#backorder-message').hide();
						$('.edd-container').show();
						$('.online-price[data-catentry='+catentryid+']').data('inv', 'IN_STOCK');
						if (isRegionalPdtAvlble && !isEDDItem) {
							$('.primary-clause').show();
						}
					}					
	        		CMath.mathTableDisplayRules();
	        		CMath.showBundleSpecificData(data,count,size);
		        	}
	        	},fail: function(data) {
		        	CMath.handleContractPriceAjaxFailure(data);		        	
		        }
        	});
		},
		/**Iterate bundle items in order to invoke ajaxgetcontract price **/
		showBundleSpecificData : function(data,count,size){
			var productOnlinePrice=parseFloat(0.00).toFixed(2);			
			var catentryid = data.itemId;			
			var pricePerUnit="";
			var dispOnZeroInv=true; 
			var isFrozenItem = $('#isFrozenItem').val();
			var isBundleItem = $('#bundleItem').val();
			var signedIn = false;
			signedIn = COSTCO.util.getMemberCookie().signedIn;
			isRegionalPdt=COSTCO.util.islocationControlledInventoryFlow();
			isRegionalPdtAvlble=false;
			blockContractAjax = false;
			$('#product-page').addClass('ajax-busy');
			//Call AJAX to get the contract prices of the given item
			COSTCO.util.ajax({
		        url: '/AjaxGetContractPrice',
		        method: 'GET',
		        dataType: 'json',
		        data: {		         
		         itemId: encodeURIComponent(data.itemId),
		          catalogId: wcs.catalogId,		          
		          productId:data.productId[0],
		          isFrozenItem:isFrozenItem,
		          isRegionalPdt:isRegionalPdt,
		          isBundleItem:isBundleItem
		          
		        },
		        done: function(data, textStatus, jqXHR, options) {
		        	$('#product-page').removeClass('ajax-busy');
		        	
		        	CMath.showBreakdown(false); 
	        	if(data.errorMessageKey) {
		        		//setUp2DayErrorPage with zip code overlay
		        		if(data.errorMessageKey == 'ERR_2DAY_PRICE_INVALID'){
		        			CMath.handleContractPriceAjaxFailure(data);
		        		}else{
		        			CMath.setUp2DayErrorPage();	
			        		if(!signedIn){
			        			$('.view-zip-signin').removeClass('hide');
			        		}
			        		$('.grocery-zip-form').removeClass('hide');
			        		$('.your-price .value').text('- -.- -');
			        		$('.unitcurrency').text('$-.- -'); 
			        		$('.math-table').show();
			        		$('#price-per-unit-container').show();
			        		//Paint the error message on the zip code overlay
			        		if(data.errorMessageKey!='ERR_ZIP_NOTVALID'){
			        			$('.alert-notification').empty();
				        		$('.critical-notification').empty();
			        			let error = COSTCO.util.get_decoded_html(data.errorMessage);
			        			
			        			if(data.errorMessageKey != 'ERR_2DAY_NOT_AVAILABLE' && data.errorMessageKey != 'ERR_2DAY_ITEM_UNAVAILABLE'
			        				&& data.errorMessageKey != 'ERR_LOCATIONCONTROLLED_ITEM_UNAVAILABLE'){
			        				error = error.replace(/[0-9]*\./,$.cookie('invCheckPostalCode')+'.');
			        			}
			        			CMath.addBorderToShipItMolecule('default'); 
			        			$('.alert-notification').append(error);
			        			$('.alert-notification').removeClass('hide');
			        			$('.critical-notification').addClass('hide');
			        		}
		        		}
	        			$('.online-price[data-catentry='+catentryid+']').data('inv', COSTCO.util.productConstants.zipcodeAvailCheck_StatusFail);
	        			$('.edd-container').hide();
	        			$('#edd-message-block').hide();
	        			$('#backorder-message').hide();
	        	}else{
	        		//Added logic to retrive minimumItemPrice for bundle
		        	bundlePriceMap.set(data.itemId,data.finalOnlinePrice);
		        	if(count+1 == size){
		        		var minItemPrice=data.finalOnlinePrice;
		        		bundlePriceMap.forEach((values,keys)=>{
		        		var currentPrice =values;
		        		if(currentPrice < minItemPrice)
		        			minItemPrice=currentPrice.toString();
		        		});
		        		$('#starting-bundle-price').text('$'+phelper.formatMoney(phelper.processPrice(minItemPrice)));
		        	}
		        		productOnlinePrice = data.finalOnlinePrice;	
		        		pricePerUnit=data.pricePerUnit;
		        		$('#bundle-info-container[data-product='+count+'] .price span').text('$'+phelper.formatMoney(phelper.processPrice(productOnlinePrice)));
		        		discount=data.discount;
		        		catentryid=data.itemId;
		        		//if there exists value for price
		        		if( typeof productOnlinePrice !== 'undefined' && (!isNaN(productOnlinePrice))){
		        			//if there exists value for discount, show discount node
		        			//Paint the contract price on PDP and encode the final item price to PDP page
		        			$('.online-price[data-catentry='+catentryid+'] .op-value').text(phelper.formatMoney(phelper.processPrice(productOnlinePrice)));		        			
		        			$('.online-price[data-catentry='+catentryid+']').data('opvalue', COSTCO.util.encode(productOnlinePrice+''));  
			        		$('#price-per-unit-container').addClass('hide');			        			
			        		//Handle other render events - 
		        			//Rules to hide/show UI elements , based on bussines requirement -
		        			//This will only be executed after Successfull price update.
		        			//CMath.pricingInfo($('.online-price[data-catentry='+catentryid+']').data('catentry'));		        			
		        		} 			        			        		
		        	}
		        	 },fail: function(data) {
		        	CMath.handleContractPriceAjaxFailure(data);		        	
		        }	
		        });
		},
		
		/**
		 * Handles Ajax failure scenario, painting the refresh button and 
		 * critical error message.
		 */
		handleContractPriceAjaxFailure: function(data){
			CMath.setUp2DayErrorPage();
        	//Hide prices and show Refresh Item Details button with error message
        	$('#price-per-unit-container').addClass('hide');
        	$('#product-page').removeClass('ajax-busy');
        	$priceSection = $('#productPriceSection');
        	$priceSection.hide();
        	$('.product-interaction').hide();
        	$('#refreshSection').removeClass('hide');
        	$("#RefreshBtn").attr("disabled", false);
        	if(retryCount == retryLimit){
        		$('div#criticalMsg1').removeClass('hide');
        		$('button#RefreshBtn').addClass('hide'); 
        	}
		},
		/**
		 * Performs string manipulations to extract warehouse number from warehouse cookie
		 * based on catalog type.
		 */
		fetchWarehouseCookieVal : function(catalogType) {
			var result = $('#defWHCookieVal').val();
			var warehouseCookie = $.cookie('WAREHOUSEDELIVERY_WHS');
			if(warehouseCookie != null && warehouseCookie != ''){
				var cookieArray = warehouseCookie.split(',');
	    		for(index in cookieArray){
	    			var cookieVal=cookieArray[index];
	    			if(cookieVal.toLowerCase().includes(catalogType.toLowerCase())){
	    				result = cookieVal.split('=').length==2?cookieVal.split('=')[1]:$('#defWHCookieVal').val();			
	    			}
	    		}
			}    		
    		return result;
		},
		//Grocery US change - Depot Catalog Online - Should not show espots, discount, fee in case of errors
		setUp2DayErrorPage : function() {			   		
    		$functionalElements = $('.grocery-espot-class,.marketing-container,.delivery-fee');
    		$functionalElements.remove();
		},
		//Rule to invoke Ajax call for contract specific data
		isContractSpecificAjaxRequired : function() {
			return COSTCO.util.isDepotCatalogEnabled() && (COSTCO.util.islocationControlledInventoryFlow() || COSTCO.util.issiteControlledInventoryFlow() )&& !blockContractAjax;
		},
		//Hide functional elements before ajax
		hideElementsBeforeAjax : function() {			   		
			$functionalElements = $('.math-table,#taxable-item,#qty-decrement,#qty-input,#qty-increment,#variants,#add-to-cart,#qty,#price-per-unit-container');
			$functionalElements.hide();
			$('.grocery-zip-form').addClass('hide');
		},
		//Show Availability for regional items
		showLocationControlledInventoryItemsAvailability() {
			var targetedCartBehaviour= $('#targetedCartBehaviour').val()==="Membership"?true:false;
			var scheduledDeliverable = $('#scheduledDeliverable').val()=="true"?true:false;
			if(scheduledDeliverable){
				$functionalElements = $('.math-table,#taxable-item,#qty-decrement,#qty-input,#qty-increment,#qty');	
			}else{
				$functionalElements = $('.math-table,#taxable-item,#qty-decrement,#qty-input,#qty-increment,#add-to-cart,#qty');
			}
			if(!targetedCartBehaviour && !scheduledDeliverable){
			if (retryCount <= retryLimit && isRegionalPdtAvlble){
				//Basically , changes to show the PDP as OOS INSTOCK , based on AJAX response ie , based on contract is done here .
				//Here changes are made to handle the pdt image and add to cart section , when the product is made INSTOCK for the customer selected
				//zipcode (ffm center based on zip code)
				var atcMsg=messages.ADDTOCART;
				$('img.oos-overlay').addClass("hide");
				$("input[type='button'][name='add-to-cart']").attr("disabled", false).val(atcMsg).attr("disabled", false).removeClass("out-of-stock");				
				$('li#add-to-cart,li#add-to-cart-map').val(atcMsg).removeClass("out-of-stock");
				$functionalElements.show();
			} else if(retryCount <= retryLimit && !isRegionalPdtAvlble){
				//Basically , changes to show the PDP as OOS(Out of Stock) , based on AJAX response ie , based on contract is done here .
				//Here changes are made to handle the pdt image and add to cart section , when the product is made OOS for the customer selected
				//zipcode (ffm center based on zip code)
				if(backordered){
                    var atcMsg=messages.ADDTOCART;
                    $('img.oos-overlay').addClass("hide");
                    $("input[type='button'][name='add-to-cart']").attr("disabled", false).val(atcMsg).attr("disabled", false).removeClass("out-of-stock");                
                    $('li#add-to-cart,li#add-to-cart-map').val(atcMsg).removeClass("out-of-stock");
                    $functionalElements.show();
                }else{
                	var oosMsg=messages.ADDTOCART_OUTOFSTOCK;
                	$functionalElements.show();
                	$('#qty-decrement,#qty-input,#qty-increment,#qty').hide();
                	 if( isPDPVariantGreyOutEnabled == 'false'){
                         $('img.oos-overlay').removeClass("hide"); 
                          }
                	$("input[type='button'][name='add-to-cart']").attr("disabled", true).val(oosMsg).attr("disabled", true).addClass("out-of-stock");				
                	$('li#add-to-cart,li#add-to-cart-map').val(oosMsg).addClass("out-of-stock");
                }
			}
			}else{
				$functionalElements.show();
			}
			this.showSelectedOptions();
		},
		
		strikealllevelvariants : function(){
			 let optionsSelected = COSTCO.Product.get_selected_array($('.varis[data-product=0]').find('option:selected'));
			 var len =optionsSelected.length;
		var itemCount =0,oosCount=0;
		if(COSTCO.Product.item_type === 'multi_variant' && optionsSelected.length ==3 ){
			for(var i = 0; i < product.length; i++) {
				for(var j = 0;j < products[i].length; j++){
				var itemId = products[i] [j].partNumber;
						if(products[i][j].options.includes(optionsSelected[0])){
							itemCount++;
					 for(var k in COSTCO.CMath.variantJSON){
				       				var val = COSTCO.CMath.variantJSON[k];
				       			    for(var l in val){
				       			        var sub_key = l;
				       			        var sub_val = val[l];
				       			        if(sub_key == itemId && (sub_val.OL == '0' && sub_val.WH == '0')){
				   		        		oosCount++;
				       			     }
				   		        }
				       			}
							}
				}
				if(oosCount == itemCount){
	        		 $('#swatchesID-productOption0'+parseInt(optionsSelected.length-2)+'').find('.selection-box-v2:visible').each(function(){
	        				 if(!$(this).find('span.selection-item').hasClass('span1-outofstock')) {
	        				    	$(this).find('span.selection-item').addClass("span1-outofstock");
	        				    	if(! $(this).find('span.selection-item').children('p').length){
	        			                $(this).find('span.selection-item').append('<p class="p-outofstock"><span class="sr-only"></span></p>');
	        			                $(this).find('span.selection-item').find('.p-outofstock span.sr-only').text(' '+messages.PDETAIL_IMAGE_OUT_OF_STOCK_ALT);
	        			                }  
	        				    }
	        			 });
	        			  variable= $('input[value=' +optionsSelected[0]+ ']').next().attr("automation-id");
	      			   if(!$('span[automation-id='+variable+']').hasClass('span1-outofstock')) {
	      			    	$('span[automation-id='+variable+']').addClass("span1-outofstock");
	      			    	if(! $('span[automation-id='+variable+']').children('p').length){
	      		                $('span[automation-id='+variable+']').append('<p class="p-outofstock"><span class="sr-only"></span></p>');
	      		                $('span[automation-id='+variable+']').find('.p-outofstock span.sr-only').text(' '+messages.PDETAIL_IMAGE_OUT_OF_STOCK_ALT);
	      		                }  
	      			    }
	      			  COSTCO.Product.appendLabelSwatches(len-3);
	      			  $('.varis-v2[automation-id=varisSwatch_0'+parseInt(optionsSelected.length-2)+']').find('option.opt:not(:disabled)').each(function(){
	      				 if(! $(this).hasClass('out-of-stock')) {
	      					 $(this).append('<span class="out-of-stock-text"></span>');
	      					 $(this).find('.out-of-stock-text').text('  '+messages.PDETAIL_IMAGE_OUT_OF_STOCK_ALT );
	      				       $(this).addClass("out-of-stock");
	      				 }
				});
	      			 if(! $('.varis-v2 option[automation-id=varisOption_'+optionsSelected[len-3]+']').hasClass('out-of-stock')) {
	      				 $('.varis-v2 option[automation-id=varisOption_'+optionsSelected[len-3]+']').append('<span class="out-of-stock-text"></span>');
	      				 $('.varis-v2 option[automation-id=varisOption_'+optionsSelected[len-3]+']').find('.out-of-stock-text').text('  '+messages.PDETAIL_IMAGE_OUT_OF_STOCK_ALT );
	      			       $('.varis-v2 option[automation-id=varisOption_'+optionsSelected[len-3]+']').addClass("out-of-stock");
	      				       var $selectedOptionLabel = $('label[for=productOption0'+parseInt(len-3)+']');
	      						var $selectedOptionValue = $selectedOptionLabel.find('.selectedOptionValue');
	      				       if(! $selectedOptionValue.text().includes(' - '+ messages.PDETAIL_IMAGE_OUT_OF_STOCK_ALT )){
	      				    	   const textToReplace =  $selectedOptionValue.text();
	      				    	   const newText = textToReplace.replace(messages.PDETAIL_IMAGE_OUT_OF_STOCK_ALT, "");
	      				    	   $selectedOptionValue.text(newText);
	      				    	   $selectedOptionValue.append(' - '+ messages.PDETAIL_IMAGE_OUT_OF_STOCK_ALT );
	      				       }
	      						$selectedOptionValue.show();
	      			 }
	}
			}
		}
		},

		// Rules to hide/show the math-table / price-breakdown based on business requirements. 
		mathTableDisplayRules : function(){ 
			var status = COSTCO.TOBACCO.userMemberInfo(), hasLicense = status.hasLicense != 'undefined' ? status.hasLicense : false;
			var userInfo = COSTCO.util.getMemberCookie(), signedIn = userInfo.signedIn, costcoMember = userInfo.costcoMember != 'undefined' ? userInfo.costcoMember : false,
			isCostcoMembers = costcoMember;
			isUserSignedIn = signedIn;
			memberOnly =  $('#memberItem').val()=="true"? true:false, 
			mapItem = $('#mapItem').val()=="true"?true:false,
			tobaccoProduct =  $('#tobaccoProduct').val()=="true"?true:false,
			inStock =  $('#outOfStock').val()=="true"?true:false,
			$functionalElements = $('.math-table,#taxable-item,#qty-decrement,#qty-input,#qty-increment,#add-to-cart,#qty,#price-per-unit-container');
			$functionalElementsTob = $('#qty-decrement,#qty-input,#qty-increment,#variants,#add-to-cart,#qty');
			
			let $signInToBuy = (costcoStoreFeatures.WEBSITE_REDESIGN_V2_PDP_FEATURE_ENABLE) ? $('.sign-in-to-buy') : $('#sign-in-to-buy');
			
			var validated = userInfo.validated;
			var verified = userInfo.verified;
			var memberActive = userInfo.active;
			blockContractAjax = false;
			
			$('#link-membership').hide();
			$('#link-membership-v2').hide();
			$('#purchase-membership').hide()
			$('#renew-membership').hide();
			$('.mem-button').hide();
			var zipcode = $.cookie('WC_BD_ZIP');
			var appType = $('#applicationType').val();
			if(zipcode!='' && zipcode!= null || appType=='BC') {
				$('.social-share-link').show();
			} else {
				$('.social-share-link').hide();
			}
			if(isRegionalPdt){
				COSTCO.CMath.showLocationControlledInventoryItemsAvailability();
			} else if (mapItem && !memberOnly) { // map item
				if (signedIn && costcoMember) { 
					$functionalElements.show(); 
					$('#sign-in-for-details').hide();
					$signInToBuy.hide();
					$('#sign-in-to-buy-v2').hide();
					this.showSelectedOptions();
				} else if (!signedIn && !costcoMember) { 
							$functionalElements.hide();
							blockContractAjax = true;
						} else if (signedIn && !costcoMember) { 
									$functionalElements.hide();
									$('#sign-in-for-details').hide();
									$signInToBuy.hide(); 
									$('#sign-in-to-buy-v2').hide(); 
									$('#add-to-cart-map').show();
									this.showSelectedOptions();
									blockContractAjax = true;
								} else if (!signedIn && costcoMember){
											$('#sign-in-for-details').hide();
											$signInToBuy.hide(); 
											$('#sign-in-to-buy-v2').hide();
											blockContractAjax = true;
										}
			} else if(tobaccoProduct) {     // tobacco product 
				if(signedIn) {
					$('#sign-in-for-details').hide();
					$('#yellow-alert').show();
					if(inStock){
						if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_PDP_FEATURE_ENABLE) {
							document.getElementById('add-to-cart-btn').disabled=false;
						} else {
							if (hasLicense) { 
								document.getElementById('add-to-cart-btn').disabled=false;
							} else{
								document.getElementById('add-to-cart-btn').disabled=true;
							}
						}
					}
				} else {
					var zipcode = $.cookie('WC_BD_ZIP');
					if(zipcode!='' || zipcode!= null) {
						$functionalElementsTob.hide();
						$('#sign-in-for-details').show();
					}
				}
			} else if (memberOnly) { // member only item
				$('#prod-page-delivery').removeClass('hide');
				if (!signedIn) {
					let rememberedShowMemberItem = $.cookie('rememberedShowMemberItem');
					if (typeof rememberedShowMemberItem !== 'undefined' && rememberedShowMemberItem !== null) {
						$('#sign-in-to-buy, .mem-button').hide();
						$('#price-per-unit-container').removeClass('hide');
						this.showSelectedOptions();
						$('#sign-in-to-buy-v2, .sign-in-to-buy').hide();
						$('.sign-in-to-buy').removeClass('interaction-element');
					} else {
					    $functionalElements.hide();
					    $('.mem-button').hide();
					    $signInToBuy.show();
					    if(COSTCO.CMath.iskitsbundle){
					    $('#bundle-button-container').hide();
					    }
					    $('#sign-in-to-buy-v2').show();
					    if ($('#scheduledDeliverable').val() === 'true') {
					    	$('#sign-in-to-buy-button-v2').removeClass('primary-button-v2').addClass('secondary-button-v2');
					    }
					    if ($('#edd-form-block').length > 0 && !$('#edd-form-block').hasClass('hidden') && !COSTCO.CMath.iskitsbundle) {
					    	$('#sign-in-to-buy-button-v2').removeClass('primary-button-v2').addClass('secondary-button-v2');
					    }
					    if ($('#edd-form-block').length > 0 && !$('#edd-form-block').hasClass('hidden') && COSTCO.CMath.iskitsbundle && !inStock) {
					    	$('#sign-in-to-buy-button-v2').removeClass('primary-button-v2').addClass('secondary-button-v2');
					    }
					    blockContractAjax = true;
					}
				} else {
					if (costcoMember) {
						if(validated || verified ){
							$signInToBuy.hide();
							$('.mem-button').hide();
							$('#sign-in-to-buy-v2').hide();
							$('#price-per-unit-container').removeClass("hide");
							if(memberActive) {								
								this.showSelectedOptions();
								var scheduledDeliverable = $('#scheduledDeliverable').val()=="true"?true:false;
								if($('#isBDAppVar').val() != 'BD' && !scheduledDeliverable){
									var atcMsg=messages.ADDTOCART;
                                    $('img.oos-overlay').addClass("hide");
                                    $("input[type='button'][name='add-to-cart']").attr("disabled", false).val(atcMsg).attr("disabled", false).removeClass("out-of-stock");                
                                    $('li#add-to-cart,li#add-to-cart-map').val(atcMsg).removeClass("out-of-stock");
                                    $functionalElements.show();
                                    if(initalizeAjaxCall && !isRegionalPdtAvlble && !backordered){
                                        var oosMsg=messages.ADDTOCART_OUTOFSTOCK;
                                                    $('#qty-decrement,#qty-input,#qty-increment,#qty').hide();
                                                    if( isPDPVariantGreyOutEnabled == 'false'){
                                                   $('img.oos-overlay').removeClass("hide"); 
                                                    }
                                        $("input[type='button'][name='add-to-cart']").attr("disabled", true).val(oosMsg).attr("disabled", true).addClass("out-of-stock");                
                                        $('li#add-to-cart,li#add-to-cart-map').val(oosMsg).addClass("out-of-stock");
                                    }
								}else if($('#isBDAppVar').val() != 'BD' && scheduledDeliverable){
									$functionalElements = $('.math-table,#taxable-item,#qty-decrement,#qty-input,#qty-increment,#qty,#price-per-unit-container');
									$functionalElements.show();
								}
							} else {
								$functionalElements.hide();
								if(COSTCO.CMath.iskitsbundle){
								    $('#bundle-button-container').hide();
							    }
								$('#renew-membership').show();
								blockContractAjax = true;
							}
						} else {
							$functionalElements.hide(); 
							$('.mem-button').hide();
							$signInToBuy.hide();
							$('#sign-in-to-buy-v2').hide();
							$('#link-membership').show();
							$('#link-membership-v2').show();
							$('#purchase-membership').show();
							if(COSTCO.CMath.iskitsbundle){
							    $('#bundle-button-container').hide();
						    }
							blockContractAjax = true;
						}
					} else {
						$functionalElements.hide();
						$signInToBuy.hide();
						$('#sign-in-to-buy-v2').hide();
						$('#link-membership').show();
						$('#link-membership-v2').show();
						$('#purchase-membership').show();
						if ($('#scheduledDeliverable').val() === 'true') {
							$('#link-membership-for-price').removeClass('primary-button-v2').addClass('secondary-button-v2');
						}
						if(COSTCO.CMath.iskitsbundle){
						    $('#bundle-button-container').hide();
						}
						blockContractAjax = true;
					}
				}
			} else if($('#isBDAppVar').val() != 'BD' && !isRegionalPdt && initalizeAjaxCall ){
				COSTCO.CMath.showLocationControlledInventoryItemsAvailability();
			}else {
				if(($('#isBDAppVar').val() == 'BD' || !initalizeAjaxCall) && !isRegionalPdt){
					$functionalElements.show();
				}
				this.showSelectedOptions();
			}
				if($('#isBDAppVar').val() == 'BD' && $('#edd-form-block').length > 0 && !isRegionalPdt){
					$('#add-to-cart-btn').attr("disabled", true);
				}
			if( $('.oos-notify-me-v2').length == 0) {
				$('#ctas').removeClass('hide');
			}
			//Call this method to change border color of ShipIt molecule in BC flow
			CMath.addBorderToShipItMolecule();
		},
		/**This function is called only in BC flow to change the 
		 * border color of ShipIt Molecule to green when item available and border is deemphasized when item out of stock   
		 */
		addBorderToShipItMolecule : function(border){
			if('BC'=== $('#applicationType').val()){
				if(typeof border === 'undefined'&& $('#add-to-cart').is(':visible')){
					var atc = document.getElementById('add-to-cart-btn');
                    if(null != atc)
						border= document.getElementById('add-to-cart-btn').disabled ? 'outOfStock' : 'available' ;		
				}
				switch (border){
					case 'available' :
						$('.product-interaction').addClass('delivery-mol-border-green');
						break;
					case 'outOfStock' :
						$('.product-interaction').removeClass('delivery-mol-border-green');
						$('.product-interaction').addClass('delivery-border');
						break;
					default :
						$('.product-interaction').removeClass('delivery-mol-border-green');
					 	$('.product-interaction').removeClass('delivery-border');
				}
			}	
		},
         /**
		 * This function is called when a swatch color tile is clicked and
		 * the Rich FX event is triggered for switching colors.
		 * During the event, Rich FX calls RMActiveColor, which contains this function.
		 * We need to select the corresponding value in our Select element
		 * and mimick a normal varis selection.
		 */
		triggerSwatchTilesSelection : function(activeColor, activeElement){
			
			var preselectAttrsStr = COSTCO.util.getParameterByName('preselect');
			var swatchMode = $('.swatchDropdown').data('swatch-mode');
			if ( (!initSwatch) && typeof preselectAttrsStr !== 'undefined' && preselectAttrsStr != null && preselectAttrsStr != 'null' && preselectAttrsStr.length > 0 && typeof swatchMode !== 'undefined' && swatchMode == 2) {
				initSwatch = true;
				var preselectattr = preselectAttrsStr.split(':').length > 1 ? preselectAttrsStr.split(':')[1] : activeColor;
				$('#productOption00 option.opt').each(function() {
					if($(this).text().toLowerCase() == preselectattr || $(this).data('swatch') == preselectattr) {
						$(this)[0].selected = true;
						activeColor = preselectattr;
						console.log('Selecting preselect of '+preselectattr);
						CMath.updateSwatchToPreselect(preselectattr.split(' ').join(''));
					}
				});
			}
			
			activeColor = DOMPurify.sanitize(activeColor);
			var $swatchElement = $('[data-swatch=' + activeColor + ']');
				$swatchElement.prop('selected', true);
				if(COSTCO.CMath.swatchInitialTileSelected && activeColor != COSTCO.CMath.swatchActiveColor ){
					COSTCO.CMath.swatchActiveColor = activeColor;
					COSTCO.CMath.swatchTileSelected = true;
				}else if(!COSTCO.CMath.swatchInitialTileSelected && activeColor == COSTCO.CMath.swatchActiveColor ){ 
					COSTCO.CMath.swatchTileSelected = false;
				}
				 if (COSTCO.CMath.iskitsbundle && COSTCO.CMath.kbPageloadComplete ) {
					 CMath.redirectPDP();
				 }else{
					 $swatchElement.trigger('change.vari'); 
				 }
				
				var colorsNames = $.map($('[data-swatch]', '.swatchDropdown'), function(option) { 
					if($(option).text().includes(messages.BACKORDER_TEXT)) {
						var sliceStr = ' - '+ messages.BACKORDER_TEXT;
						return $(option).text().slice(0, $(option).text().indexOf(sliceStr))+ " -"+$(option).data('swatch').trim().toLowerCase()+"-";
					} else if($(option).text().includes(messages.OUT_OF_STOCK_TEXT)) {
						var sliceStr = ' - '+ messages.OUT_OF_STOCK_TEXT;
						return $(option).text().slice(0, $(option).text().indexOf(sliceStr))+ " -"+$(option).data('swatch').trim().toLowerCase()+"-";
					} else if($(option).text().includes(' -')) {
						return $(option).text().slice(0, $(option).text().indexOf(' -'))+ " -"+$(option).data('swatch').trim().toLowerCase()+"-";
					} else {
						return $(option).text() + " -"+$(option).data('swatch').trim().toLowerCase()+"-";
					}
				});
				var colorNameTitle = $.map(colorsNames, function (value){
					if(value.includes(' -'+activeColor+'-')){
						return value.slice(0, value.indexOf(' -'+activeColor+'-')); 
					}
				});
				
				if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_PDP_FEATURE_ENABLE) {
					var colorNameSpan = document.createElement("SPAN");
					$(colorNameSpan).text(messages.COLOR + ': ' + colorNameTitle);
					$(colorNameSpan).addClass('bold');

					$('label[for="theSwatches"]').html(colorNameSpan);
					$('label[for="pdpSwatches"]').html(colorNameSpan);

				} else {
				$('label', '#variants .variantContainer').first().text(messages.COLOR + ': ' +colorNameTitle);
				}

				$('img', '#theSwatches').each(function() {						
					var swatchElement = $(this).siblings('span.RICHFXColorChangeSwatchName')[0];
					if(typeof swatchElement !== 'undefined' && swatchElement !== null ){
						var itemDescriptionArray = $(this).siblings('span.RICHFXColorChangeSwatchName')[0].innerHTML.split(" ");
						if(itemDescriptionArray.length == 2) {
							if(typeof($(this).parent().find('#selectedOffScreenSwatch')) !== 'undefined' ){
								$(this).parent().find('#selectedOffScreenSwatch').each(function () {
									$(this).remove();
								});
							}
							if(itemDescriptionArray[1].toLowerCase() === activeColor) {
								$(this).parent().prepend('<span id="selectedOffScreenSwatch" class="offscreen">Selected</span>');
							}
						}
					}
				});
		},
		
		updateSwatchToPreselect: function(color) {
			$('.RICHFXColorChangeLink span').each(function(){
				var swatchIdx = $(this).html().indexOf(' ' + color)  ;
				if(swatchIdx >= 0 && $(this).html().substr(swatchIdx+1) == color){
					$(this).next().click();
				}
			});
		},
		
		runRMAActiveColor : function (event, color) {
			if(event.keyCode == 13){
				event.preventDefault();
				console.log("Pressed enter key with color : " + color);
				// The space at the beginning is added so blue won't match against lightblue.
				CMath.updateSwatchToPreselect(color);
			}
		},
		
		/**
		 * This function is called to  the stock availability using the response from the GE webservice. 
		 * Adding the 'X' on the swatch and making it disabled. Also reseting it when we re call the service. 
		 * We're using '-' as delimiter for the swatch code and swatch description and inventory status and if price added than that too..
		 *  
		 */
		updateGEStockAvailability: function (){
			var colorsNames = $.map($('[data-attr-name="Color"]', '.swatchDropdown'), function(option) { 
				if($(option).text().includes(messages.BACKORDER_TEXT)) {
					var sliceStr = ' - '+ messages.BACKORDER_TEXT;
					return $(option).text().slice(0, $(option).text().indexOf(sliceStr))+ " -"+$(option).data('swatch').trim().toLowerCase()+"-";
				} else if($(option).text().includes(messages.OUT_OF_STOCK_TEXT)) {
					var sliceStr = ' - '+ messages.OUT_OF_STOCK_TEXT;
					return $(option).text().slice(0, $(option).text().indexOf(sliceStr))+ " -"+$(option).data('swatch').trim().toLowerCase()+"-";
				} else if($(option).text().includes(' -')) {
					return $(option).text().slice(0, $(option).text().indexOf(' -'))+ " -"+$(option).data('swatch').trim().toLowerCase()+"-";
				} else {
					return $(option).text() + " -"+$(option).data('swatch').trim().toLowerCase()+"-";
				}
			});
			//span.RICHFXColorChangeSwatchName has the name in format '1 colorname' to we split it on space and on index 1 we get colorname.
			//and for french also , the colorname from RICHFX is also same. 
			
			$('[data-attr-name="Color"]', '.swatchDropdown').each(function() {
				var swatchElement = $(this)[0];
				if(typeof swatchElement !== 'undefined' && swatchElement !== null){
	            	var color = $(swatchElement).data('swatch').trim().toLowerCase();
						var colorNameTitle = $.map(colorsNames, function (value){
							if(value.includes(' -'+color+'-')){
								return value.slice(0, value.indexOf(' -'+color+'-')); 
							}
						});
						
					var colorsOutStock =  $.map($('[data-attr-name="Color"]', '.swatchDropdown'), function(option) {
							if($(option).data('swatch') === color) {
								for(var i = 0; i < products[0].length; i++) {
								if((products[0][i].options.length === 1 && $(option).val() === products[0][i].options[0]) || 
									(products[0][i].options.length === 2 && ($(option).val() === products[0][i].options[0] || $(option).val() === products[0][i].options[1])) ){
									if(products[0][i].zipcodeAvailabilityMessageCode === COSTCO.util.productConstants.inv_backorderd){
										if($(option).text().includes(messages.OUT_OF_STOCK_TEXT)){
											var sliceStr = ' - '+ messages.OUT_OF_STOCK_TEXT;
											var optionText = $(option).text().slice(0, $(option).text().indexOf(sliceStr));
											$(option).text(optionText);
										}
										if(! $(option).text().includes(messages.BACKORDER_TEXT)){
											var message = $(option).text() + ' - '+ messages.BACKORDER_TEXT;
											$(option).text(message);
										}
									}
									if(products[0][i].zipcodeAvailabilityMessageCode === COSTCO.util.productConstants.inv_outOfStock || products[0][i].zipcodeAvailabilityMessageCode === COSTCO.util.productConstants.inv_invalidSku){
																			
										if($(option).text().includes(messages.BACKORDER_TEXT)){
											var sliceStr = ' - '+ messages.BACKORDER_TEXT;
											var optionText = $(option).text().slice(0, $(option).text().indexOf(sliceStr));
											$(option).text(optionText);
										}
										if(! $(option).text().includes(messages.OUT_OF_STOCK_TEXT)){
											var message = $(option).text() + ' - '+ messages.OUT_OF_STOCK_TEXT;
											$(option).text(message);
										}
										$(option).attr("disabled","disabled");
										return $(option).data('swatch').trim().toLowerCase(); 
									} 
								}
							}
						}
						});
					var colorsInStock =  $.map($('[data-attr-name="Color"]', '.swatchDropdown'), function(option) {
							if($(option).data('swatch') === color) {
								for(var i = 0; i < products[0].length; i++) {
								if((products[0][i].options.length === 1 && $(option).val() === products[0][i].options[0]) || 
										(products[0][i].options.length === 2 && ($(option).val() === products[0][i].options[0] || $(option).val() === products[0][i].options[1])) ){
									if (products[0][i].inventory !== COSTCO.util.productConstants.inv_outOfStock && products[0][i].zipcodeAvailabilityMessageCode !== COSTCO.util.productConstants.inv_outOfStock && products[0][i].zipcodeAvailabilityMessageCode !== COSTCO.util.productConstants.inv_invalidSku && $(option).attr("disabled") === "disabled"){
										$(option).removeAttr("disabled");
										if($(option).text().includes(messages.OUT_OF_STOCK_TEXT)) {
											var sliceStr = ' - '+ messages.OUT_OF_STOCK_TEXT;
											var message = $(option).text().slice(0, $(option).text().indexOf(sliceStr));
											$(option).text(message);
										} else if($(option).text().includes(messages.BACKORDER_TEXT)) {
											var sliceStr = ' - '+ messages.BACKORDER_TEXT;
											var message = $(option).text().slice(0, $(option).text().indexOf(sliceStr));
											$(option).text(message);
										}
										return $(option).data('swatch').trim().toLowerCase();
									}
								}
							}
						}
						});
					
					$('img', '#theSwatches').each(function() {	
						var swatchElement = $(this).siblings('span.RICHFXColorChangeSwatchName')[0];
						if(typeof swatchElement !== 'undefined' && swatchElement !== null ){
							var itemDescriptionArray = $(swatchElement)[0].innerHTML.split(" ");
							if(itemDescriptionArray.length == 2 && itemDescriptionArray[1].toLowerCase() === color){
								if(colorsOutStock[0] === color  && !$(this).parent().hasClass('disabledSwatch')) {
							$(this).parent().addClass('disabledSwatch');
							if(color == 'white'){
								$(this).parent().append('<img src="/wcsstore/RWDStaticAssets/fonts/fallback-icons/icons/swatch-disabled-grey.png" class="disableOverlaySwatch" />');
							}else {
								$(this).parent().append('<img src="/wcsstore/RWDStaticAssets/fonts/fallback-icons/icons/swatch-disabled-white.png" class="disableOverlaySwatch" />');
							}
							$(this).parent().get(0).setAttribute("tabindex", "-1");
							$(this).parent().wrap('<span class="swatch-help" data-placement="bottom" data-trigger="focus hover" tabindex="0" data-toggle="popover" data-html="true" data-content="'+colorNameTitle + ' ' + messages.OUT_OF_STOCK_TOOLTIP + '" />');
							$(this).parent().prepend('<span class="offscreen">' +colorNameTitle + ' '+ messages.OUT_OF_STOCK_TOOLTIP +'</span>');
							
							$(this).parent().get(0).removeAttribute("data-sort");
							$(this).parent().get(0).removeAttribute("data-content");
							$(this).parent().get(0).removeAttribute("data-placement");
							$(this).parent().get(0).removeAttribute("data-trigger");
							$(this).parent().get(0).removeAttribute("data-toggle");
							
							$(this).parent().get(0).removeAttribute("aria-expanded");
							$(this).parent().get(0).removeAttribute("aria-haspopup");
							$(this).parent().get(0).removeAttribute("data-original-title");
							$(this).parent().get(0).removeAttribute("role");
							$(this).parent().get(0).removeAttribute("title");
							
							$(this).parent().get(0).removeAttribute("data-html");
							$(this).parent().get(0).classList.remove("swatch-help");
							
								}
								if(colorsInStock[0] === color && $(this).parent().hasClass('disabledSwatch')){
							
							$(this).parent().removeClass('disabledSwatch');
							
							$(this).siblings('img.disableOverlaySwatch').remove();
							$(this).siblings('span.offscreen').remove();
							
							$(this).parent().get(0).setAttribute("data-sort", colorsInStock.indexOf(color));
							$(this).parent().get(0).removeAttribute("tabindex");
							$(this).parent().get(0).setAttribute("data-content", colorNameTitle);
							$(this).parent().get(0).setAttribute("data-placement", "bottom");
							$(this).parent().get(0).setAttribute("data-trigger", "focus hover");
							$(this).parent().get(0).setAttribute("data-toggle", "popover");
							$(this).parent().get(0).setAttribute("data-html", "true");
							$(this).parent().get(0).classList.add("swatch-help");
							$(this).parent().unwrap();
						}
						COSTCO.util.swatch_accesible_popover('.swatch-help');
					}
				}
            });
				}
            });
			
			//NEED FOR BF?
			if($('#theSwatches').children().length == 0){
				var itemOutStock =  $.map($('[data-swatch]', '.swatchDropdown'), function(option) {
					if($(option).data('swatch') === 'pedestal option') {
						for(var i = 0; i < products[0].length; i++) {
							if((products[0][i].options.length === 1 && $(option).val() === products[0][i].options[0]) || 
									(products[0][i].options.length === 2 && ($(option).val() === products[0][i].options[0] || $(option).val() === products[0][i].options[1])) ){
								if(products[0][i].zipcodeAvailabilityMessageCode === COSTCO.util.productConstants.inv_backorderd){
								if($(option).text().includes(messages.OUT_OF_STOCK_TEXT)){
									var sliceStr = ' - '+ messages.OUT_OF_STOCK_TEXT;
									var optionText = $(option).text().slice(0, $(option).text().indexOf(sliceStr));
									$(option).text(optionText);
								}
								if(! $(option).text().includes(messages.BACKORDER_TEXT)){
									var message = $(option).text() + ' - '+ messages.BACKORDER_TEXT;
									$(option).text(message);
								}
							}
								if(products[0][i].zipcodeAvailabilityMessageCode === COSTCO.util.productConstants.inv_outOfStock || products[0][i].zipcodeAvailabilityMessageCode === COSTCO.util.productConstants.inv_invalidSku){
																	
								if($(option).text().includes(messages.BACKORDER_TEXT)){
									var sliceStr = ' - '+ messages.BACKORDER_TEXT;
									var optionText = $(option).text().slice(0, $(option).text().indexOf(sliceStr));
									$(option).text(optionText);
								}
								if(! $(option).text().includes(messages.OUT_OF_STOCK_TEXT)){
									var message = $(option).text() + ' - '+ messages.OUT_OF_STOCK_TEXT;
									$(option).text(message);
								}
								$(option).attr("disabled","disabled");
								return $(option).data('swatch').trim().toLowerCase(); 
							}
						}
					}
					}
				});
				
				var itemsInStock =  $.map($('[data-swatch]', '.swatchDropdown'), function(option) {
					if($(option).data('swatch') === 'pedestal option') {
						for(var i = 0; i < products[0].length; i++) {
							if((products[0][i].options.length === 1 && $(option).val() === products[0][i].options[0]) || 
									(products[0][i].options.length === 2 && ($(option).val() === products[0][i].options[0] || $(option).val() === products[0][i].options[1])) ){
								if (products[0][i].inventory !== COSTCO.util.productConstants.inv_outOfStock && products[0][i].zipcodeAvailabilityMessageCode !== COSTCO.util.productConstants.inv_outOfStock && products[0][i].zipcodeAvailabilityMessageCode !== COSTCO.util.productConstants.inv_invalidSku && $(option).attr("disabled") === "disabled"){
								$(option).removeAttr("disabled");
								if($(option).text().includes(messages.OUT_OF_STOCK_TEXT)) {
									var sliceStr = ' - '+ messages.OUT_OF_STOCK_TEXT;
									var message = $(option).text().slice(0, $(option).text().indexOf(sliceStr));
									$(option).text(message);
								} else if($(option).text().includes(messages.BACKORDER_TEXT)) {
									var sliceStr = ' - '+ messages.BACKORDER_TEXT;
									var message = $(option).text().slice(0, $(option).text().indexOf(sliceStr));
									$(option).text(message);
								}
								return $(option).data('swatch').trim().toLowerCase();
							}
						}
					}
					}
				});
			}
			
			var $variant_options = $('.varis[data-product=0]').find('option:not(.defaultOpt)');
			let optionsSelected = phelper.get_selected_array($('.varis[data-product=0]').find('option:selected'));
			$variant_options.each(function(index, opt) {
				if(optionsSelected.includes(opt.value)) {
					products[0].forEach(function(product_obj) {
						CMath.update_variant_option_GE(opt, product_obj, $variant_options.length, optionsSelected );
						
					});
				}
			});
			
			
		},
		
		/**
		 * Function that disables/enables variant option and updates option text after GE Availability Call
		 */
		update_variant_option_GE: function(opt, product_obj, nextVariantLength) {
		
			if(costcoStoreFeatures.WEBSITE_REDESIGN_V2_PDP_FEATURE_ENABLE && numberOfOptionsToDisplayAsTiles && nextVariantLength < numberOfOptionsToDisplayAsTiles) {
				$(opt).siblings().each(function (index, option){
					if(typeof option.innerHTML != 'undefined' && !option.innerHTML.includes(messages.OUT_OF_STOCK_TEXT)){
						$(option).removeAttr('disabled');
					}
					if(option.innerHTML.includes(messages.BACKORDER_TEXT) || option.innerHTML.includes(messages.OUT_OF_STOCK_TEXT)){
						if(option.innerHTML.includes(messages.BACKORDER_TEXT)) {
							var sliceStr = ' - '+ messages.BACKORDER_TEXT;
							option.innerHTML = option.innerHTML.slice(0, option.innerHTML.indexOf(sliceStr));
						}
						if(option.innerHTML.includes(messages.OUT_OF_STOCK_TEXT)) {
							var sliceStr = ' - '+ messages.OUT_OF_STOCK_TEXT;
							option.innerHTML = option.innerHTML.slice(0, option.innerHTML.indexOf(sliceStr));
						}
						$(option).disabled = false;
					}
					$variant_option_input = $('input[value=' + option.value + ']');
					if(typeof ($variant_option_input.siblings('.selection-item')[0]) !== "undefined"){
						$variant_option_input.siblings('.selection-item')[0].innerHTML = option.innerHTML;
					}
					$variant_option_span = $variant_option_input.closest('span')
					if($variant_option_span.length > 0){
						if(product_obj.inventory === COSTCO.util.productConstants.inv_outOfStock  || product_obj.zipcodeAvailabilityMessageCode === COSTCO.util.productConstants.inv_invalidSku) {
							$variant_option_span.addClass('disabledSwatch');
						} else {
							$variant_option_span.removeClass('disabledSwatch');
						}
					}
				});
				$(opt).closest('label').removeClass('disabled');
			}
			if(typeof(opt.value) !== "undefined" && product_obj.options.includes(opt.value) ){
				
				if(product_obj.inventory === COSTCO.util.productConstants.inv_backorderd || (product_obj.zipcodeAvailabilityMessageCode === COSTCO.util.productConstants.inv_backorderd && product_obj.zipcodeAvailabilityResponseCode === COSTCO.util.productConstants.zipcodeAvailCheck_StatusFail) ) {
					
					if($(opt)[0].innerHTML.includes(messages.OUT_OF_STOCK_TEXT)){
						var sliceStr = ' - '+ messages.OUT_OF_STOCK_TEXT;
						$(opt)[0].innerHTML = $(opt)[0].innerHTML.slice(0, $(opt)[0].innerHTML.indexOf(sliceStr));
					}
					if(!$(opt)[0].innerHTML.includes(messages.BACKORDER_TEXT)){
						$(opt)[0].innerHTML += ' - '+ messages.BACKORDER_TEXT;
					}
					
				} else if(product_obj.inventory === COSTCO.util.productConstants.inv_outOfStock ||  product_obj.zipcodeAvailabilityMessageCode === COSTCO.util.productConstants.inv_outOfStock || product_obj.zipcodeAvailabilityMessageCode === COSTCO.util.productConstants.inv_invalidSku) {
					
					if($(opt)[0].innerHTML.includes(messages.BACKORDER_TEXT)){
						var sliceStr = ' - '+ messages.BACKORDER_TEXT;
						$(opt)[0].innerHTML = $(opt)[0].innerHTML.slice(0, $(opt)[0].innerHTML.indexOf(sliceStr));
					}
					if(! $(opt)[0].innerHTML.includes(messages.OUT_OF_STOCK_TEXT)){
						$(opt)[0].innerHTML += ' - '+ messages.OUT_OF_STOCK_TEXT;
					}
					if(product_obj.zipcodeAvailabilityMessageCode !== COSTCO.util.productConstants.inv_outOfStock) {
						if(costcoStoreFeatures.WEBSITE_REDESIGN_V2_PDP_FEATURE_ENABLE && numberOfOptionsToDisplayAsTiles && nextVariantLength < numberOfOptionsToDisplayAsTiles) {
							$(opt).siblings().attr('disabled', 'disabled');
							$(opt).closest('span').addClass('disabled');
						}
						$(opt).attr('disabled', 'disabled');
					}
					
				}
				
				if(costcoStoreFeatures.WEBSITE_REDESIGN_V2_PDP_FEATURE_ENABLE && numberOfOptionsToDisplayAsTiles && nextVariantLength < numberOfOptionsToDisplayAsTiles) {
					if(typeof(opt.value) !== "undefined" ){
						$variant_option_input = $('input[value=' + opt.value + ']');
						if(typeof ($variant_option_input.siblings('.selection-item')[0]) !== "undefined"){
							$variant_option_input.siblings('.selection-item')[0].innerHTML = $(opt)[0].innerHTML;
						}
						$variant_option_span = $variant_option_input.closest('span')
						if($variant_option_span.length > 0){
							if(product_obj.inventory === COSTCO.util.productConstants.inv_outOfStock  || product_obj.zipcodeAvailabilityMessageCode === COSTCO.util.productConstants.inv_invalidSku) {
								$variant_option_span.addClass('disabledSwatch');
							} else {
								$variant_option_span.removeClass('disabledSwatch');
							}
						}
						
					}
				}
			}
		},
		/**
		 * This function is called when a color is selected in our swatch dropdown.
		 * We need to trigger a click event on Rich FX's swatch color tiles in order
		 * for the zoomviewer to correctly update to the chosen color. The swatch color
		 * tiles should be hidden when our swatch color dropdown is showing.
		 */
		triggerSwatchDropDownSelection : function(swatchColor){
			
			if(typeof swatchColor == 'undefined' || swatchColor == ''){
				return;
			}
			
			// The space at the beginning is added so blue won't match against lightblue.
			$('.RICHFXColorChangeLink span.RICHFXColorChangeSwatchName').each(function(){
				var swatchIdx = $(this).html().indexOf(' ' + swatchColor)  ;
				if(swatchIdx >= 0 && $(this).html().substr(swatchIdx+1) == swatchColor){
					var $theViews = $('#theViews');
					if($theViews) {
						$theViews.find('img').each(function(){
							$(this).off("click");
						});
					}
					$(this).next().click();						
					if($theViews) {
						$theViews.find('img').each(function(){
							$(this).on('click', function(event){
								$(this).on("click");
							});		
						});
					}					
				}
			});
			
		},
		// displays the lowest price of all variants when no variants are selected
		showLowestPriceVariant : function() {
			if (phelper.isSingleVariant(products) || phelper.isMultiVariant(products)){
				var catentry = products[0][0].catentry;
				var minPrice = this.calculateYourPrice(catentry,true);
				var maxPrice = this.calculateYourPrice(catentry,true);
					for (var i = 0, len = products[0].length; i < len; i++) {
						if(minPrice > this.calculateYourPrice(products[0][i].catentry, true)){
							minPrice = this.calculateYourPrice(products[0][i].catentry, true);
							catentry = products[0][i].catentry;
						}
						else if(maxPrice < this.calculateYourPrice(products[0][i].catentry, true)){
							maxPrice = this.calculateYourPrice(products[0][i].catentry, true);
						}
						
					}
				if(minPrice === maxPrice){
					$('.starting-price').hide();
				} else {
					$('.starting-price').show();
				}
				this.pricingInfo(catentry);
				this.showBreakdown(true);
			}
		},
		// determines price to show for same price variants
		showPriceVariants : function() {
		    if (phelper.isSingleVariant(products) || phelper.isMultiVariant(products)) {
		        // Get the price of the first product from the products array to compare
		        var catentry = products[0][0].catentry,
		             price = this.calculateYourPrice(catentry, true);
		        // Check to see if every other variant has the same price
		        for (var i = 0, len = products[0].length; i < len; i++) {
		            var item_price = this.calculateYourPrice(products[0][i].catentry, true);
		            if (price != item_price) {
		                break;
		            }
		            if (i == len-1) {
		                this.pricingInfo(catentry);
		                this.showBreakdown(true);
		            }
		        }
		    }
		},
		optionsInStockMAP : function(){
			var inStockMap = {};
			
			for(var j=0; j < options.length; j++){			// options Sku level count
				for(var k=0; k < options[j].length; k++){	// options Sku attribute level count
					var skuAttr = options[j][k];
					if( skuAttr && skuAttr.s && skuAttr.s > 0){
						//Key - optiondesc, value = Swatch type and value
						var mapValue = {'swatchable_mode':skuAttr.s,'vimage':skuAttr.vimage};
						inStockMap[skuAttr.i] = mapValue;
					}
				}
			}
			return inStockMap;
		},
		showBackorderMessage : function() {
			if (typeof backorderMessage !== "undefined") {
	            $('#backorder-message').removeClass('hide');
	            $('#backorder-message').html(backorderMessage);
	        }
		},
		showSelectedOptions : function(){
			// GE scheduled deliverable
			var scheduledDeliverable = $('#scheduledDeliverable').val()=="true"?true:false;
			$schDeliveryElements = $('#select-options');
			
			if(scheduledDeliverable){
				$schDeliveryElements.show();
				$('#prod-page-delivery').removeClass('hide');
				$('#add-to-cart').hide();
				$('#add-to-cart-map').hide();
			}
		},
		handleEDDForms : function() {
			
			
			
			eddInstallationServicesJSON = {};
			if (!$('#vendorName').val() || phelper.item_type == 'bundle') {
				$('#liveEDD').val("false");
				$('#edd-message-block').hide();
				$('.edd-container').hide();
				$('.primary-clause').show();
				
				if(COSTCO.util.checkElementById('#outOfStock', 'true'))
				{
					COSTCO.Product.enableAddtoCart();
				}
			} else {
				$('#liveEDD').val("true");
				$('.primary-clause').hide();
				$('#edd-message-block').show();
			}
		},
		formatMaxShipDate: function(startDate) {
		    var d = new Date(startDate),
		        month = '' + (d.getMonth() + 1),
		        day = '' + d.getDate(),
		        year = d.getFullYear();

		    if (month.length < 2) 
		        month = '0' + month;
		    if (day.length < 2) 
		        day = '0' + day;
		    
		    var langId= COSTCO.util.getLangId();
		    if (langId === '-25') {
		    	 return [day,month,year].join('/');	
		    }
		    else {
		    	 return [month,day,year].join('/');	
		    }
		},
		
		isValidShipMode: function(defaultShipcode) {
			if (defaultShipcode && (defaultShipcode.toLowerCase() == messages.SHIPCODE_NO_SHIPPING || defaultShipcode.toLowerCase() == messages.SHIPCODE_MAIL)){
				return false;
			} else {
				return true;
			}					
		},
		invokeBuildABundle : function(catentryid){
			if(COSTCO.CMath.iskitsbundle){
                var itemPartNumber = COSTCO.Product.getPartnumber();
                var ItemType = 'single';
                if(ItemType != phelper.item_type){
                	ItemType = 'variant';
                }
                var varaintParameters = {"partNumber":itemPartNumber,"catentryId":catentryid,"ItemType":ItemType};
                window.reactObj.bundle.partNumber = itemPartNumber;
                window.reactObj.bundle.catentryId = catentryid;
                window.reactObj.bundle.ItemType = ItemType;
                try {
                   if(typeof varaintParameters != undefined) {
                       window.wioEventBus.publish('bundleDataRequest',varaintParameters);
                   }
                } catch(e) {
                   console.log(e);
                }
			}
		},
		invokeBundleSetForPDP : function(virtualBundleID){
			try {
				if(typeof virtualBundleID != undefined) {
	        	   	var itemType = 'single';
	        	   	if(itemType != phelper.item_type){
	        	   		itemType = 'variant';
	        	   	}
	        	   	var inputJson = {partNumber:COSTCO.Product.getPartnumber(), ItemType:itemType, virtualBundleID:virtualBundleID};
	        	   	window.wioEventBus.publish('displayBundlePackage', inputJson);
           		}
        	} catch(e) {
	           console.log(e);
	        }
		
		},selectNextSwatch : function(id,count){
			var activeColor= id.split('_')[1];
			var imageId =count+"_"+activeColor;
			if(activeColor != COSTCO.CMath.swatchActiveColor){
				 $('.selectedSwatch').removeClass('selectedSwatch');
				 $("#"+id).addClass("selectedSwatch");
				 $('img').removeClass('kBSwatchSelected');
				 $("#"+imageId).removeClass("kBSwatchUnSelected");
				 $("#"+imageId).addClass("kBSwatchSelected");
				 COSTCO.CMath.setKbLabel();
				var $swatchElement = $('[data-swatch=' + activeColor + ']');
				$swatchElement.prop('selected', true);
				if(COSTCO.CMath.swatchInitialTileSelected && activeColor != COSTCO.CMath.swatchActiveColor ){
					COSTCO.CMath.swatchActiveColor = activeColor;
					COSTCO.CMath.swatchTileSelected = true;
				}
				 if (COSTCO.CMath.iskitsbundle && COSTCO.CMath.kbPageloadComplete) {
					 CMath.redirectPDP();
				 }
			}
			
			
		},
		 setKbLabel : function(){
			 var labelColor= $(".selectedSwatch").attr("data-content");
			 $('label[for="theKBSwatches"]').html('<span class="bold">Color: </span>' + labelColor);
		},
		buildTooltip: function() {
			$('body').append('<div id="KBTooltipId" class="popover fade bottom in" style=" display: block;position:absolute;visiblity:hidden;">'+
					'<div class="arrow" style="left: 50%;"></div><div class="popover-content"></div></div>');
		},
		showKBTooltip: function(data) {
			var index = data.id.split('_')[0];
			var labelColor= $('#'+data.id).attr("data-content");
			var target = $('#'+data.id);
			$('#KBTooltipId').removeClass('hide');
			$('#KBTooltipId .popover-content').html(target.attr('data-content'));
			// update text
			target.attr('title', '');
			var tt =$('#RICHFXTooltip').offset();
			var absoluteOffset = target.offset();
			// following code for setting top postion
			var topPosition = "38";
			var actLeftPosition = parseFloat(absoluteOffset.left) ;
			var actTopPosition = parseFloat(absoluteOffset.top) + parseFloat(topPosition);
			$('#KBTooltipId').css('top', parseFloat(actTopPosition)+'px');
			// following code for setting left postion
			const element = document.getElementById("KBTooltipId");
			const rect = element.getBoundingClientRect();
			var widthfalf = rect.width/2;
			actLeftPosition = actLeftPosition - widthfalf + 20;
			$('#KBTooltipId').css('left', parseFloat(actLeftPosition)+'px');
			$('#KBTooltipId').css('visibility', 'visible');
		},	 hideKBTooltip: function(data) {
			var index = data.id.split('_')[0];
			$('#KBTooltipId').css('visibility', 'hidden');
		},
		
		redirectPDP : function(){
			let optionsSelected = COSTCO.Product.get_selected_array($('.varis[data-product=0]').find('option:selected'));
			const equalOption = (optionsSelected.length === COSTCO.CMath.onloadSelectOption.length)
			&& optionsSelected.every((value, index) => value === COSTCO.CMath.onloadSelectOption[index]); 
			if(!equalOption){
				var isPreviousSwatchAvailable=false;
				var reloadProductUrl;
				 const arr1 = optionsSelected.concat().sort();
				  for(var i = 0; i < product.length; i++) {
					  if(products[i] != undefined){
						  products[i].forEach( list => {
							  const arr2 = list.options.concat().sort();
							  const equalValues = (arr2.length === arr1.length) && arr2.every((value, index) => value === arr1[index]); 
							  if(equalValues){
								  isPreviousSwatchAvailable=true;
								  reloadProductUrl= list.productUrl;
								  return;
							  }
						  });
					  }
				  }
				  if(!isPreviousSwatchAvailable){
					  CMath.redirectwithFirstItem(optionsSelected);
				  }
				  if(isPreviousSwatchAvailable){
					// disable swatch
				        $(".RICHFXColorChangeLink").addClass('disabledSwatch');//disable image
				        if(undefined !=optionsSelected){
				        	for(var i=0;i<optionsSelected.length;i++){
				        		 var swatch=$('#swatches-productOption0'+i+'').length > 0 ;
								 var dropDown=$('.varis-v2[automation-id=varisSwatch_0'+i+']').length>0 ;
				        		 if (swatch) {
				        			 $("#swatchesID-productOption0"+i+"").attr('disabled', 'disabled');//disable tile swatches
				        		 }else if(dropDown){
				        			$('.varis-v2[automation-id=varisSwatch_0'+i+']').attr('disabled', 'disabled') ;//disable dropdown
				        		 }
				            }
				        }
				       
					 document.location.href = reloadProductUrl+"?isSwatchReload";
				  }
				
			
			}
		},reloadOnRadio : function(radioId,inputLevel){
			
			var level = inputLevel.replace('productOption0','');
			var tileId = radioId.split('_')[1];
			$('.radio-padding[automation-id=selectionItem_'+tileId+']').addClass("select-radio-remove-boarder");
				let optionsSelected = COSTCO.Product.get_selected_array($('.varis[data-product=0]').find('option:selected'));
				 if ($('#swatches-productOption0'+level+' .selection-box-v2 input').length > 0) {
	        		  let firstSelectedVariant  = $('#swatches-productOption0'+level+' input[value='+tileId+']');
	        		  $('#productOption0'+level).val($(firstSelectedVariant).val());
	        		  $variant_option_input = $('input[value=' + tileId + ']');
	        		  $variant_option_input.prop('checked', true);
	        		  CMath.redirectPDP();
	        	  }
		},redirectwithFirstItem : function(optionsSelected){
				var reloadPage=false;
				for(var i = 0; i < product.length; i++) {
					  if(products[i] != undefined){
						  products[i].forEach( list => {
							  list.options.forEach( option => {
									if(optionsSelected[0]== option){
										reloadPage=true;
										reloadProductUrl= list.productUrl;
										return;
									}
								 });
						  });
					  }
				  }
				if(reloadPage){
					 document.location.href = reloadProductUrl+"?isSwatchReload";
				}
				
		},selectCurrentSelectedItem : function() {
				 $('.variantContainer select.varis option').each(function(index, inputVar){
					$(inputVar).removeAttr('checked');
					$(inputVar).attr('aria-checked', 'false');
					$(inputVar).attr('selected', false);
				});
				var selectedAttribute = $('#selectedSwatchAttr').val();
				if(   null != selectedAttribute && undefined != selectedAttribute && selectedAttribute != ""){
					selectedAttribute = selectedAttribute.replace('[', '').replace(']', '');
					 var arrayselect=[];
					 arrayselect= selectedAttribute.split(',');
					 arrayselect.forEach( option => {
						//Swatch selection
						
						if($("#activeswatch_"+option.split('#')[1]+"").length > 0){
							$("#activeswatch_"+option.split('#')[1]+"").addClass('selectedSwatch');
							$("#activeswatch_"+option.split('#')[1]+"").attr('aria-pressed', 'true');
							$("#activeswatch_"+option.split('#')[1]+" img").removeClass('kBSwatchUnSelected');
							$("#activeswatch_"+option.split('#')[1]+" img").addClass('kBSwatchSelected');
						}
						//Tiles selection
						 $('.variantContainer select.varis option').each(function(index, inputVar){
							 if($(inputVar).val() == option.split('#')[0].trim() ){
								 $(inputVar).prop('checked', true);
									$(inputVar).attr('aria-checked', 'true');
									$(inputVar).attr('selected', true);
									$(inputVar).addClass('selection-item');
							 }
								
							});
						//Dropdown selection
						 let optionsSelected = COSTCO.Product.get_selected_array($('.varis[data-product=0]').find('option:selected'));
						// const arr1 = optionsSelected.concat().sort();
						 let noOflevels =optionsSelected.length;
						 var dropDown=$('.varis[automation-id=varisSwatch_0'+parseInt(noOflevels-1)+']').length>0 ;
						 var options =[];
						if(noOflevels > 1 && dropDown ){
							  for(var i = 0; i < product.length; i++) {
								  if(products[i] != undefined){
									  products[i].forEach( list => {
										  if(list.options.includes(optionsSelected[0])){
											  list.options.forEach( opt => {
												  if(opt != optionsSelected[0]){
													  options.push(opt);
												  }
												 
											  });
										  }
									  });
								  }
							  }
							  if(options.length > 0){
								  $('.varis[automation-id=varisSwatch_0'+parseInt(noOflevels-1)+']').find('option.opt:not(:disabled)').each(function(){
										 if (!options.includes($(this).attr("value"))){
											 var opt=$(this).attr("value");
							  				 $variant_option_input =$('.varis [automation-id=varisOption_'+opt+']');
											  if($variant_option_input.length > 0){
												  $variant_option_input.attr('disabled', 'disabled').hide();
												  $variant_option_input.prop('checked', false);
											  } 
										 }
									 });
							  }
							  }
							
					 });
				}
				
				
			},hideKBSkeletone : function() {
				 let optionsSelected = COSTCO.Product.get_selected_array($('.varis[data-product=0]').find('option:selected'));
				$('#PDPSwatchSkeletone-productOption0'+parseInt(optionsSelected.length-1)+'').hide();
				$('#swatchesID-productOption0'+parseInt(optionsSelected.length-1)+'').show();
				$('.dropdown-skeleton-productOption0'+parseInt(optionsSelected.length-1)+'').hide();
				$('[name=productOption0'+parseInt(optionsSelected.length-1)+']').show();
		  
			}

	}
	if(typeof window.COSTCO == 'undefined'){
		window.COSTCO = new Object();
	}
	window.COSTCO.CMath = CMath;
	
    return CMath;
    
});


// WEBPACK FOOTER //
// ./js/product/mathtable.js